(function () {
    'use strict';

    // Configuration will be loaded from window.PREORDER_CONFIG
    const PREORDER_CONFIG = window.PREORDER_CONFIG || {};

    // Enable debug by default if not explicitly set
    if (PREORDER_CONFIG.enableDebug === undefined) {
        PREORDER_CONFIG.enableDebug = true;
    }

    // Turkish to English label translations (display only - original values sent to backend)
    const LABEL_TRANSLATIONS = {
        // ============================================
        // OZELLIK BASLIKLARI (PROPERTY NAMES) - 52 adet
        // ============================================
        'ANA GRUP': 'MAIN GROUP',
        'SEZON': 'SEASON',
        'PAKETLEME': 'PACKAGING',
        'PAKETLEME 2': 'PACKAGING 2',
        'BEDEN GRUBU': 'SIZE GROUP',
        'MUSTERI': 'CUSTOMER',
        'BEDEN': 'SIZE',
        'ASORTI': 'ASSORTMENT',
        'ADET': 'QUANTITY',
        'AY PARCASI': 'BACK NECK PATCH',
        'VARYANT UST': 'VARIANT TOP',
        'VARYANT ALT': 'VARIANT BOTTOM',
        'UST KUMAS': 'TOP FABRIC',
        'ALT KUMAS': 'BOTTOM FABRIC',
        'YAKA TIPI': 'COLLAR TYPE',
        'YAKA TIPI 2': 'COLLAR TYPE 2',
        'TUNIK YAKA TIPI': 'TUNIC COLLAR TYPE',
        'KOL TIPI': 'SLEEVE TYPE',
        'KOL TIPI 2': 'SLEEVE TYPE 2',
        'SABAHLIK KOL TIPI': 'ROBE SLEEVE TYPE',
        'TUNIK KOL TIPI': 'TUNIC SLEEVE TYPE',
        'BLUZ FORMU': 'BLOUSE FORM',
        'SABAHLIK BLUZ FORMU': 'ROBE BLOUSE FORM',
        'TUNIK BLUZ FORMU': 'TUNIC BLOUSE FORM',
        'PACA (ALT MODEL)': 'LEG TYPE',
        'CEP SECENEK': 'POCKET',
        'CEP SECENEK 1': 'POCKET OPTION 1',
        'CEP SECENEK 2': 'POCKET OPTION 2',
        'SABAHLIK CEP SECENEK': 'ROBE POCKET OPTION',
        'SABAHLIK CEP SECENEK 2': 'ROBE POCKET OPTION 2',
        'KEMER': 'BELT',
        'KORDON': 'CORD',
        'SABAHLIK KEMER': 'ROBE BELT',
        'DUGME': 'BUTTON',
        'DUGME 1': 'BUTTON 1',
        'DUGME 2': 'BUTTON 2',
        'FERMUAR': 'ZIPPER',
        'FERMUAR 1': 'ZIPPER 1',
        'FERMUAR 2': 'ZIPPER 2',
        'DANTEL': 'LACE',
        'DANTEL 1': 'LACE 1',
        'DANTEL 2': 'LACE 2',
        'BIYE SECENEK 1': 'BINDING OPTION 1',
        'BIYE SECENEK 2': 'BINDING OPTION 2',
        'BIBILA SECENEK 1': 'PIPING OPTION 1',
        'BIBILA SECENEK 2': 'PIPING OPTION 2',
        'AKSESUAR': 'ACCESSORY',
        'TUNIK AKSESUAR': 'TUNIC ACCESSORY',
        'FIYONK': 'BOW',
        'PARCA BASKI': 'PIECE PRINT',
        'PARCA BASKI YERI': 'PIECE PRINT LOCATION',
        'NOT': 'NOTE',

        // ============================================
        // OZELLIK DEGERLERI (PROPERTY VALUES) - 165+ adet
        // ============================================

        // Ana Grup Degerleri
        'UYKU GIYIM': 'SLEEPWEAR',

        // Beden Grubu Degerleri
        'NORMAL BEDEN': 'REGULAR SIZE',
        'BUYUK BEDEN': 'PLUS SIZE',

        // Evet/Hayir
        'VAR': 'YES',
        'YOK': 'NO',
        'GENEL': 'GENERAL',

        // Kol Tipi Degerleri
        'KISA KOL': 'SHORT SLEEVE',
        'UZUN KOL': 'LONG SLEEVE',
        '3/4 KOL': '3/4 SLEEVE',
        'IP ASKILI': 'THIN STRAP',
        'KALIN ASKILI': 'THICK STRAP',

        // Yaka Tipi Degerleri
        'V YAKA': 'V NECK',
        'O YAKA': 'O NECK',
        'BISIKLET YAKA': 'CREW NECK',
        'PATLI DAMLA YAKA': 'DROP NECK',
        'GOMLEK YAKA': 'SHIRT COLLAR',
        'YAKA CEVRESINDEN ETEGE BIYE': 'BINDING FROM COLLAR TO HEM',

        // Bluz Formu Degerleri
        'OVAL ETEK': 'OVAL HEM',
        'DUZ ETEK': 'STRAIGHT HEM',

        // Alt Model Degerleri
        'SORT': 'SHORTS',
        'KAPRI': 'CAPRI',
        'UZUN PACA': 'LONG LEG',

        // Cep Degerleri
        'YANDAN CEP': 'SIDE POCKET',
        'USTTEN CEP': 'TOP POCKET',

        // Kemer Degerleri
        'KIVIRMA': 'FOLDOVER',

        // Kumas Degerleri
        'PENYE SUPREM': 'SUPREME JERSEY',
        'POLYVISCON': 'POLYVISCOSE',

        // Paketleme Degerleri
        'PVC': 'PVC',
        'SEFFAF POSET - KUCUK RESIMLI KART - VIENETTA ENSE ETIKETI': 'TRANSPARENT BAG - SMALL PICTURE CARD - VIENETTA BACK LABEL',

        // Sezon Degerleri
        '2026 YAZ': '2026 SUMMER',
        '2026 YAZ DEGERLENDIRME': '2026 SUMMER EVALUATION',

        // Baski Yeri Degerleri
        'SOL GOGUS': 'LEFT CHEST',
        'SOL GOGUSTE': 'ON LEFT CHEST',
        'ORTADA GOGUS': 'CENTER CHEST',
        'ORTADA GOGUSTE': 'ON CENTER CHEST',
        'SOL VE SAG GOGUSTE': 'ON LEFT AND RIGHT CHEST',
        'ETEKTE': 'ON HEM',
        'SOL ETEKTE': 'ON LEFT HEM',
        'PACADA': 'ON LEG',
        'SOL GOGUSTE VE ETEKTE': 'ON LEFT CHEST AND HEM',
        'SOL GOGUSTE VE ORTADA': 'ON LEFT CHEST AND CENTER',
        'SOL GOGUSTE VE PACADA': 'ON LEFT CHEST AND LEG',
        'ORTADA GOGUSTE VE ETEK UCUNDA': 'ON CENTER CHEST AND HEM END',

        // Renkler (Turkce)
        'PEMBE': 'PINK',
        'A.PEMBE': 'LIGHT PINK',
        'BEYAZ': 'WHITE',
        'LACIVERT': 'NAVY BLUE',
        'LACI': 'NAVY',
        'MAVI': 'BLUE',
        'KOYU KREM': 'DARK CREAM',
        'BEJ MEL': 'BEIGE MELANGE',
        'G2 MEL': 'G2 MELANGE',
        'KF1 MEL': 'KF1 MELANGE',
        'EG MAVI': 'EG BLUE',

        // Renkler (Ingilizce - oldugu gibi)
        'PINK': 'PINK',
        'SOFT PINK': 'SOFT PINK',
        'WILD ROSE': 'WILD ROSE',
        'BLUE HAZE': 'BLUE HAZE',
        'SMOKE BLUE': 'SMOKE BLUE',
        'AQUA FOAM': 'AQUA FOAM',
        'HONEY GOLD': 'HONEY GOLD',
        'GOLDEN NUGGET': 'GOLDEN NUGGET',
        'SUNBURST': 'SUNBURST',
        'SUPER LEMON': 'SUPER LEMON',

        // Varyant/Rotasyon Degerleri
        'ROTASYON': 'ROTATION',
        'ZEMIN': 'BASE',
        'METRAJ ZEMIN': 'METRAGE BASE',
        'AYAR HALKA': 'ADJUSTABLE RING',
        'A-ROTASYON': 'A-ROTATION',
        'A-PEMBE': 'A-PINK',
        'A-MAVI': 'A-BLUE',
        'A-LACIVERT': 'A-NAVY BLUE',
        'A-KOYU KREM': 'A-DARK CREAM',
        'A-ZEMIN': 'A-BASE',
        'A-A.PEMBE': 'A-LIGHT PINK',
        'A-HONEY GOLD': 'A-HONEY GOLD',
        'A-KAR MELANJ': 'A-SNOW MELANGE',
        'A-KAR MELNAJ': 'A-SNOW MELANGE',
        'A-ANTRASIT MEL': 'A-ANTHRACITE MELANGE',
        'A-G2 MEL': 'A-G2 MELANGE',
        'A-EG MAVI': 'A-EG BLUE',
        'A-ROTASYON (GRI ZEMIN)': 'A-ROTATION (GREY BASE)',
        'A-ROTASYON (LACIVERT ZEMIN)': 'A-ROTATION (NAVY BASE)',
        'ROTASYON (GRI ZEMIN)': 'ROTATION (GREY BASE)',
        'ROTASYON (LACIVERT ZEMIN)': 'ROTATION (NAVY BASE)',

        // Ozel Kodlar
        'EG-0': 'EG-0',
        'EG-1': 'EG-1',
        'AHF0': 'AHF0',
        'IF1': 'IF1',

        // Pantone Renk Kodlari
        'A-11-0606': 'A-11-0606 (Pantone)',
        'A-11-1001': 'A-11-1001 (Pantone)',
        'A-11-1408': 'A-11-1408 (Pantone)',
        'A-12-0812': 'A-12-0812 (Pantone)',
        'A-13-1404': 'A-13-1404 (Pantone)',
        'A-13-2003': 'A-13-2003 (Pantone)',
        'A-13-4103': 'A-13-4103 (Pantone)',
        'A-13-4210': 'A-13-4210 (Pantone)',
        'A-13-4910': 'A-13-4910 (Pantone)',
        'A-13-6008': 'A-13-6008 (Pantone)',
        'A-14-4121': 'A-14-4121 (Pantone)',
        'A-15-5313': 'A-15-5313 (Pantone)',
        'A-16-3812': 'A-16-3812 (Pantone)',
        'A-18-1630': 'A-18-1630 (Pantone)',
        'A-18-4006': 'A-18-4006 (Pantone)',
        'A-19-3922': 'A-19-3922 (Pantone)',
        'A-19-3923': 'A-19-3923 (Pantone)',
        'A-19-3925': 'A-19-3925 (Pantone)',
        'A-19-3933': 'A-19-3933 (Pantone)',
        'A-19-3939': 'A-19-3939 (Pantone)',

        // Adet Degerleri
        '10 ADET': '10 PIECES',
        '6 ADET': '6 PIECES',
        '8 ADET': '8 PIECES',

        // Notlar ve Talimatlar
        'KUMAS SIFIRLANACAK': 'FABRIC WILL BE RESET',
        'KUMASIN SIFIRLANACAK': 'FABRIC WILL BE RESET',
        'DEGERLENDIRME OLACAK': 'TO BE EVALUATED',
        'DEGERLENDIRME OLACAK.': 'TO BE EVALUATED',
        'DEGERLENDRIME OLACAK.': 'TO BE EVALUATED',

        // Renk Talimatlari
        'ZEMIN RENGI ROTASYON ZEMINDEN ALINACAK.': 'BASE COLOR WILL BE TAKEN FROM ROTATION BASE',
        'KOYU KREM RENGI ROTASYONDAN ALINACAK': 'DARK CREAM COLOR WILL BE TAKEN FROM ROTATION',
        'KOYU KREM RENGI ROTASYONDAN ALINACAK.': 'DARK CREAM COLOR WILL BE TAKEN FROM ROTATION',
        'LACIVERT RENK ROTASYONDAN ALINACAK.': 'NAVY COLOR WILL BE TAKEN FROM ROTATION',
        'PEMBE RENK ROTASYONDAN ALINACAK.': 'PINK COLOR WILL BE TAKEN FROM ROTATION',
        'KIRMIZI RENK ROTASYONDAN ALINACAK.': 'RED COLOR WILL BE TAKEN FROM ROTATION',
        'A.PEMBE RENGI ROTASYONDAN ALINACAK.': 'LIGHT PINK COLOR WILL BE TAKEN FROM ROTATION',

        // Dugme Talimatlari
        'DUGME RENGI ROTASON ICINDEN ALINACAK.': 'BUTTON COLOR WILL BE TAKEN FROM ROTATION',
        'DUGME RENGI ROTASONDAN ALINACAK.': 'BUTTON COLOR WILL BE TAKEN FROM ROTATION',
        'DUGME RENGI ROTASON ZEMIN RENGI ILE AYNI OLACAK.': 'BUTTON COLOR WILL BE SAME AS ROTATION BASE',
        'DUGME RENGI ROTASYON ZEMIN ILE AYNI OLACAK.': 'BUTTON COLOR WILL BE SAME AS ROTATION BASE',
        'DUGME RENGI ROTASYON ZEMIN RENGI ILE AYNI OLACAK.': 'BUTTON COLOR WILL BE SAME AS ROTATION BASE COLOR',
        'DUGME KIRMIZI RENGI ROTASYONDAN ALINACAK.': 'BUTTON RED COLOR WILL BE TAKEN FROM ROTATION',
        'DUGME VE BIYE RENKLERI BLUZ RENKLERI ILE AYNI OLACAK.': 'BUTTON AND BINDING COLORS WILL BE SAME AS BLOUSE COLORS',
        'DUGME VE BIYE RENKLERI ROTASON ZEMIN RENGI ILE AYNI OLACAK.': 'BUTTON AND BINDING COLORS WILL BE SAME AS ROTATION BASE COLOR',

        // Biye Talimatlari
        'BIYE RENGI ROTASYON ZEMIN RENGI ILE AYNI OLACAK.': 'BINDING COLOR WILL BE SAME AS ROTATION BASE COLOR',
        'BIYE RENKLERI ROTASYON ZEMIN ILE AYNI OLACAK.': 'BINDING COLORS WILL BE SAME AS ROTATION BASE',
        'BIYE RENKLERI ROTASYON ZEMIN RENGI ILE AYNI OLACAK.': 'BINDING COLORS WILL BE SAME AS ROTATION BASE COLOR',
        'BIYE RENKLERI ROTASYON ZEMIN RENKLERI ILE AYNI OLACAK.': 'BINDING COLORS WILL BE SAME AS ROTATION BASE COLORS',
        'BIYE RENKLERI BLUZ RENKLERI ILE AYNI OLACAK.': 'BINDING COLORS WILL BE SAME AS BLOUSE COLORS',

        // Bibila Talimatlari
        'BIBILA RENKLERI ROTASYON ZEMIN RENGI ILE AYNI OLACAK.': 'PIPING COLORS WILL BE SAME AS ROTATION BASE COLOR',

        // Fiyonk Talimatlari
        'FIYONK RENGI PUAN RENGI ILE AYNI OLACAK.': 'BOW COLOR WILL BE SAME AS DOT COLOR',

        // Kordon Talimatlari
        'KORDON RENGI ALT RENGI ILE AYNI OLACAK.': 'CORD COLOR WILL BE SAME AS BOTTOM COLOR',

        // Yaka Biye Talimatlari
        'YAKA BIYE RENGI BLUZ RENKLERI ILE AYNI OLACAK.': 'COLLAR BINDING COLOR WILL BE SAME AS BLOUSE COLORS',
        'YAKA VE CEP UCU BIYE RENGI BLUZ RENKLERI ILE AYNI OLACAK.': 'COLLAR AND POCKET TIP BINDING COLOR WILL BE SAME AS BLOUSE COLORS',

        // Varyant Talimatlari
        'A VARYANT ICIN KAR MELANJ, B VARYANTI ICIN 14-4318': 'SNOW MELANGE FOR A VARIANT, 14-4318 FOR B VARIANT',
        'A VARYANTTA 19-3933, B VARYANTTA KAR MELANJ': '19-3933 FOR A VARIANT, SNOW MELANGE FOR B VARIANT',

        // RPT (Repeat) Talimatlari
        '3050550601 RPT OLACAK.': '3050550601 REPEAT WILL BE USED',
        '4020180601 RPT OLACAK.': '4020180601 REPEAT WILL BE USED',
        '5033071248 RPT.': '5033071248 REPEAT',
        '5033091248 RPT OLACAK. FIYONK PUAN RENGI ILE AYNI OLACAK.': '5033091248 REPEAT WILL BE USED. BOW WILL BE SAME AS DOT COLOR',
        '5033111248 RPT OLACAK. FIYONK PUAN RENGI ILE AYNI OLACAK.': '5033111248 REPEAT WILL BE USED. BOW WILL BE SAME AS DOT COLOR',
        'RPT 5033320000 OLACAK.': 'REPEAT WILL BE 5033320000',
        'MODEL,PARCA BASKI VE RENKLER 3040550601 ILE AYNI OLACAK.': 'MODEL, PIECE PRINT AND COLORS WILL BE SAME AS 3040550601',

        // Zemin Kodlari
        '580 (GRI ZEMIN) - 300 (PEMBE ZEMIN)': '580 (GREY BASE) - 300 (PINK BASE)',
        '580 (UST GRI ZEMIN) - 300 (UST PEMBE ZEMIN)': '580 (TOP GREY BASE) - 300 (TOP PINK BASE)'
    };

    // Translate label (returns English if translation exists, otherwise original)
    // KZK: translateLabels === false ise orijinal (Turkce) deger gosterilir
    function translateLabel(label) {
        if (!label) return label;
        if (PREORDER_CONFIG.translateLabels === false) return label;
        const upperLabel = label.toUpperCase().trim();
        return LABEL_TRANSLATIONS[upperLabel] || label;
    }

    // Translate option summary string (e.g., "YAKA TIPI: VALUE | KOL TIPI: VALUE")
    // Hem label hem de value'yu cevirir
    function translateOptionSummary(summary) {
        if (!summary) return summary;
        // Split by | and translate each label AND value
        return summary.split('|').map(part => {
            const colonIndex = part.indexOf(':');
            if (colonIndex === -1) return translateLabel(part.trim());
            const label = part.substring(0, colonIndex).trim();
            const value = part.substring(colonIndex + 1).trim();
            const translatedLabel = translateLabel(label);
            const translatedValue = translateLabel(value);
            return `${translatedLabel}: ${translatedValue}`;
        }).join(' | ');
    }

    let isInitialized = false;
    let debugInfo = [];
    let minProductionInfo = 1;
    let preorderGroups = [];
    let basePrice = 0;
    let currentPrice = 0;
    let originalAddToCartButton = null;
    let setSize = 1; // ASORTI set size (e.g., 1-1-1-1 = 4)

    function debug(message, data = null) {
        if (!PREORDER_CONFIG.enableDebug) return;

        const timestamp = new Date().toLocaleTimeString();
        const logMessage = `[${timestamp}] ${message}`;

        debugInfo.push(logMessage);
        console.log('[Preorder Debug]', logMessage, data || '');

        const debugEl = document.getElementById('preorder-debug');
        if (debugEl) {
            debugEl.innerHTML = debugInfo.slice(-10).join('<br>');
            debugEl.style.display = 'block';
        }
    }

    function ready(fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    function getCurrencySymbol(currency) {
        const symbols = {
            'USD': '$',
            'EUR': '€',
            'GBP': '£',
            'TRY': '₺',
            'TL': '₺'
        };
        return symbols[currency] || '$';
    }

    function updatePrice() {
        const priceDisplay = document.getElementById('preorder-current-price');
        const quantityInput = document.getElementById('preorder-quantity');

        if (priceDisplay) {
            const shopifyCurrency = window.Shopify?.currency?.active || 'USD';
            const currencySymbol = getCurrencySymbol(shopifyCurrency);

            // Adet ile çarpma işlemi
            const quantity = parseInt(quantityInput?.value || 1, 10) || 1;
            const totalAmount = currentPrice * quantity;

            priceDisplay.innerHTML = `<span class="glc-money" translate="no">${currencySymbol}${totalAmount.toFixed(2)}</span>`;
        }

        debug(`Price updated: ${currentPrice.toFixed(2)} x ${quantityInput?.value || 1} = ${(currentPrice * (parseInt(quantityInput?.value || 1, 10) || 1)).toFixed(2)}`);
    }

    function updateOptionPrices() {
        const selects = document.querySelectorAll('#preorder-dynamic-fields select');

        selects.forEach(select => {
            const selectedValue = select.value;
            let selectedPrice = 0;

            // Seçili olan seçeneğin fiyatını bul
            if (selectedValue) {
                const selectedOption = Array.from(select.options).find(opt => opt.value === selectedValue);
                selectedPrice = parseFloat(selectedOption?.dataset.price || 0);
            }

            // Tüm seçenekleri güncelle
            Array.from(select.options).forEach(option => {
                if (!option.value || option.disabled) return; // "Seçiniz..." seçeneğini atla

                const optionPrice = parseFloat(option.dataset.price) || 0;
                const originalText = option.dataset.originalText || option.textContent.split(' (')[0];

                if (!option.dataset.originalText) {
                    option.dataset.originalText = originalText;
                }

                // Cache'lenmiş çeviriyi kullan, yoksa yeniden çevir ve cache'le
                let displayText = option.dataset.translatedText;
                if (!displayText) {
                    displayText = translateLabel(originalText);
                    option.dataset.translatedText = displayText;
                }

                // Ensure translate="no" is set to prevent external translation tools
                if (!option.getAttribute('translate')) {
                    option.setAttribute('translate', 'no');
                    option.classList.add('notranslate');
                }

                // Eğer bu seçenek seçili ise fiyat gösterme
                if (option.value === selectedValue) {
                    option.textContent = displayText;
                } else {
                    // Seçili olmayan seçeneklerde fark göster
                    const priceDifference = optionPrice - selectedPrice;

                    if (priceDifference > 0) {
                        option.textContent = `${displayText} (+${priceDifference.toFixed(2)})`;
                    } else if (priceDifference < 0) {
                        option.textContent = `${displayText} (-$${Math.abs(priceDifference).toFixed(2)})`;
                    } else {
                        option.textContent = displayText;
                    }
                }
            });
        });
    }

    function calculatePrice() {
        let totalPrice = basePrice;

        // Tüm seçeneklerin fiyatlarını topla
        const selects = document.querySelectorAll('#preorder-dynamic-fields select');
        selects.forEach(select => {
            if (select.selectedIndex > 0) { // İlk option "Seçiniz..." olduğu için
                const selectedOption = select.options[select.selectedIndex];
                const price = parseFloat(selectedOption.dataset.price) || 0;
                totalPrice += price;
            }
        });

        currentPrice = Math.max(totalPrice, 0); // Negatif fiyat olmasın
        updatePrice();

        // Seçeneklerdeki fiyat görünümlerini güncelle
        updateOptionPrices();
    }

    // ============================================
    // OPTION BAZLI PROGRESS BAR FONKSIYONLARI
    // ============================================

    // Tum secili opsiyonlari topla (hem variant hem dynamic fields)
    function collectAllSelectionsForProgress() {
        const selections = {};

        // Variant fields (popup icindeki)
        const variantSelects = document.querySelectorAll('#preorder-variant-fields select');
        variantSelects.forEach(select => {
            if (select.name && select.value) {
                selections[select.name] = select.value;
            }
        });

        // Dynamic fields (preorder options)
        const dynamicSelects = document.querySelectorAll('#preorder-dynamic-fields select');
        dynamicSelects.forEach(select => {
            if (select.name && select.value) {
                selections[select.name] = select.value;
            }
        });

        return selections;
    }

    // API'den progress bilgisi cek
    async function fetchOptionProgress() {
        const selections = collectAllSelectionsForProgress();

        // Hic secim yoksa progress bar'i gizle
        if (Object.keys(selections).length === 0) {
            hideProgressBar();
            return null;
        }

        const progressContainer = document.getElementById('preorder-option-progress');
        if (!progressContainer) return null;

        // Loading goster
        progressContainer.style.display = 'block';
        progressContainer.innerHTML = '<div class="preorder-progress-loading">Sipariş durumu yükleniyor...</div>';

        try {
            // Product bilgilerini al
            const productInfo = getProductInfo();
            const productCodes = parseProductCodes(); // Urun kodlarini al (barcode/stokkodu)

            const requestBody = {
                product_handle: productInfo.handle || '',
                stokkodu: productCodes?.barcode || '',
                selections: selections
            };

            debug('[Progress] Fetching progress for selections:', selections);
            debug('[Progress] Request body:', requestBody);

            const progressUrl = (PREORDER_CONFIG.apiUrl || 'https://patronundan.com/preorders') + '/progress-by-options';
            const response = await fetch(progressUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                throw new Error(`API error: ${response.status}`);
            }

            const data = await response.json();
            debug('[Progress] API response:', data);

            if (data.ok) {
                updateProgressBar(data);
                return data;
            } else {
                throw new Error(data.error || 'Unknown error');
            }

        } catch (error) {
            console.error('[Progress] Error fetching progress:', error);
            debug('[Progress] Error:', error.message);
            hideProgressBar();
            return null;
        }
    }

    // Progress bar UI'ini guncelle
    function updateProgressBar(data) {
        const progressContainer = document.getElementById('preorder-option-progress');
        if (!progressContainer) return;

        const { progress, option_summary } = data;
        const { current, target, percentage, remaining, total_customers } = progress;

        // Renk sinifi belirle
        let colorClass = '';
        let statusIcon = '';
        if (percentage >= 100) {
            colorClass = 'complete';
            statusIcon = '';
        } else if (percentage >= 75) {
            colorClass = 'high';
            statusIcon = '';
        } else if (percentage >= 50) {
            colorClass = 'medium';
            statusIcon = '';
        } else {
            statusIcon = '';
        }

        // Progress bar HTML'ini olustur
        progressContainer.style.display = 'block';
        progressContainer.innerHTML = `
            <div class="preorder-progress-header">
                <span class="preorder-progress-title">Order Status for This Option Combination</span>
                <span class="preorder-progress-count">${statusIcon} ${current} / ${target}</span>
            </div>
            <div class="preorder-progress-bar-container">
                <div class="preorder-progress-bar ${colorClass}" style="width: ${percentage}%;"></div>
            </div>
            <div class="preorder-progress-info">
                <span>%${percentage} tamamlandı</span>
                ${remaining > 0
                    ? `<span>${remaining} adet daha gerekli</span>`
                    : '<span style="color: #38a169; font-weight: 600;">Hedef tamamlandı!</span>'}
            </div>
            ${option_summary ? `<div class="preorder-progress-summary"><strong>Options:</strong> ${translateOptionSummary(option_summary)}</div>` : ''}
            ${total_customers > 0 ? `<div style="font-size: 11px; color: #718096; margin-top: 4px;">${total_customers} customer(s) ordered this combination</div>` : ''}
        `;

        debug(`[Progress] Updated: ${current}/${target} (${percentage}%)`);
    }

    // Progress bar'i gizle
    function hideProgressBar() {
        const progressContainer = document.getElementById('preorder-option-progress');
        if (progressContainer) {
            progressContainer.style.display = 'none';
        }
    }

    // Debounce fonksiyonu - cok sik API cagrisi onlemek icin
    let progressDebounceTimer = null;
    function debouncedFetchProgress() {
        if (progressDebounceTimer) {
            clearTimeout(progressDebounceTimer);
        }
        progressDebounceTimer = setTimeout(() => {
            fetchOptionProgress();
        }, 300); // 300ms bekle
    }

    // Tum select'lere progress listener ekle
    function attachProgressListeners() {
        // Variant fields
        const variantSelects = document.querySelectorAll('#preorder-variant-fields select');
        variantSelects.forEach(select => {
            select.addEventListener('change', debouncedFetchProgress);
        });

        // Dynamic fields
        const dynamicSelects = document.querySelectorAll('#preorder-dynamic-fields select');
        dynamicSelects.forEach(select => {
            select.addEventListener('change', debouncedFetchProgress);
        });

        debug('[Progress] Listeners attached to ' + (variantSelects.length + dynamicSelects.length) + ' select elements');
    }

    // ============================================
    // OPTION BAZLI PROGRESS BAR SONU
    // ============================================

    function init() {
        if (isInitialized) {
            debug('Already initialized, skipping');
            return;
        }

        // Remove any existing progress bars from product page on init
        const existingProgressBars = document.querySelectorAll('.variant-progress-main-container, .variant-progress-container, .preorder-progress-container, #preorder-progress-bar');
        if (existingProgressBars.length > 0) {
            existingProgressBars.forEach(bar => bar.remove());
            debug('[Progress] Removed existing progress bars on init');
        }

        debug('Starting preorder initialization');
        debug('Config values:', PREORDER_CONFIG);

        const selector = PREORDER_CONFIG.sourceSelector || '#preorders';
        const preorderElement = document.querySelector(selector);

        if (!preorderElement) {
            debug(`Preorder element not found: ${selector}`);
            return;
        }

        debug('Preorder element found', preorderElement);

        const dataPreorders = preorderElement.getAttribute('data-preorders');
        if (dataPreorders !== 'true') {
            debug(`Invalid data-preorders attribute: ${dataPreorders}`);
            return;
        }

        debug('data-preorders="true" verified');

        if (PREORDER_CONFIG.requireActiveStatus) {
            const elementText = preorderElement.textContent || preorderElement.innerHTML;
            const isActive = /Ön\s*Sipariş\s*Durumu:\s*Aktif/i.test(elementText);

            debug(`Active status check: ${isActive}`, elementText.substring(0, 200));

            if (!isActive) {
                debug('Preorder status is not active, skipping');
                return;
            }
        }

        debug('All checks passed, proceeding with setup');

        minProductionInfo = extractMinProduction(preorderElement);
        basePrice = extractBasePrice(preorderElement);
        currentPrice = basePrice;
        setSize = extractSetSize(preorderElement);

        debug(`Min production: ${minProductionInfo}, Base price: ${basePrice}, Set size: ${setSize}`);

        preorderGroups = extractPreorderGroups(preorderElement);
        debug(`Found ${preorderGroups.length} preorder groups`, preorderGroups);

        if (PREORDER_CONFIG.replaceAddToCartButton) {
            replaceAddToCartButton(minProductionInfo, preorderGroups);
        } else {
            createTriggerButton(preorderElement, minProductionInfo, preorderGroups);
        }

        setTimeout(() => {
            if (PREORDER_CONFIG.hideSourceContent) {
                preorderElement.style.display = 'none';
                debug('Source element hidden');
            }

            // Sadece fiyatları gizle, varyant seçicilerini gizleme
            const priceElements = document.querySelectorAll('.price .glc-money, .price__container .glc-money, [class*="price"] .glc-money');
            priceElements.forEach(el => {
                const priceContainer = el.closest('.price, .price__container, [class*="price"]');
                // Varyant seçicilerini içermeyen sadece fiyat containerlarını gizle
                if (priceContainer &&
                    !priceContainer.id.includes('preorder') &&
                    !priceContainer.closest('.wt-product__option') &&
                    !priceContainer.closest('.product-form__input') &&
                    !priceContainer.closest('fieldset') &&
                    !priceContainer.closest('.variant-picker') &&
                    !priceContainer.closest('[data-variant-picker]')) {
                    priceContainer.style.display = 'none';
                    debug('Product page price hidden (but variants kept visible)');
                }
            });
        }, 100);

        // Ürün kodu bilgilerini başlık altında göster
        displayProductCodes();

        // Deadline countdown timer'ı göster
        displayDeadlineCountdown();

        isInitialized = true;
        debug('Preorder initialization completed');
    }

    function extractBasePrice(element) {
        let price = 0;

        // Grup fiyatlarını kontrol et (preorders div'den veya eski hidden div'den)
        const preordersDiv = document.getElementById('preorders');
        const groupPricesDiv = document.getElementById('group-prices-data');

        // Önce preorders div'den data-group-prices'ı kontrol et
        let groupPricesJson = null;
        if (preordersDiv && preordersDiv.hasAttribute('data-group-prices')) {
            groupPricesJson = preordersDiv.getAttribute('data-group-prices');
            debug('Group prices found in preorders div');
        } else if (groupPricesDiv) {
            groupPricesJson = groupPricesDiv.getAttribute('data-group-prices');
            debug('Group prices found in separate hidden div');
        }

        if (groupPricesJson) {
            try {
                const groupPrices = JSON.parse(groupPricesJson);
                debug('Group prices data:', groupPrices);

                // Müşteri giriş yapmışsa ve grubu varsa
                const customerData = getCustomerInfo();
                if (customerData.logged_in && customerData.id) {
                    const customerGroup = findCustomerGroup(customerData);

                    if (customerGroup) {
                        debug(`Customer group detected: ${customerGroup}`);

                        // Müşteri grubuna ait fiyatı al
                        const groupPrice = groupPrices[customerGroup];
                        if (groupPrice && !isNaN(parseFloat(groupPrice)) && parseFloat(groupPrice) > 0) {
                            price = parseFloat(groupPrice);
                            debug(`Base price found from customer group (${customerGroup}): ${price}`);
                            return price;
                        }
                    }
                }

                // Grup yoksa veya giriş yapmamışsa 1.Grup fiyatını kullan (varsayılan)
                const defaultPrice = groupPrices['1.Grup'] || groupPrices['2.Grup'] || groupPrices['3.Grup'];
                if (defaultPrice && !isNaN(parseFloat(defaultPrice)) && parseFloat(defaultPrice) > 0) {
                    price = parseFloat(defaultPrice);
                    debug(`Base price found from default group (1.Grup): ${price}`);
                    return price;
                }
            } catch (e) {
                debug('Error parsing group prices:', e);
            }
        }

        // Önce preorder element'inde data-base-price attribute'u ara
        const priceAttr = element.getAttribute('data-base-price');
        if (priceAttr) {
            price = parseFloat(priceAttr) || 0;
            debug(`Base price found from data attribute: ${price}`);
            return price;
        }

        // Meta tag'lardan ara
        const priceMetaSelectors = [
            'meta[property="product:price:amount"]',
            'meta[name="product:price"]',
            'meta[property="og:price:amount"]'
        ];

        for (const selector of priceMetaSelectors) {
            const meta = document.querySelector(selector);
            if (meta && meta.content) {
                price = parseFloat(meta.content) || 0;
                if (price > 0) {
                    debug(`Base price found from meta tag: ${price}`);
                    return price;
                }
            }
        }

        // JSON-LD structured data'dan ara
        try {
            const scripts = document.querySelectorAll('script[type="application/ld+json"]');
            for (const script of scripts) {
                const data = JSON.parse(script.textContent || '{}');
                if (data.offers && data.offers.price) {
                    price = parseFloat(data.offers.price) || 0;
                    if (price > 0) {
                        debug(`Base price found from JSON-LD: ${price}`);
                        return price;
                    }
                }
                if (data['@type'] === 'Product' && data.offers && Array.isArray(data.offers)) {
                    const offer = data.offers[0];
                    if (offer && offer.price) {
                        price = parseFloat(offer.price) || 0;
                        if (price > 0) {
                            debug(`Base price found from JSON-LD offers: ${price}`);
                            return price;
                        }
                    }
                }
            }
        } catch (e) {
            debug('Error parsing JSON-LD:', e);
        }

        // Shopify product object'inden ara
        if (window.meta && window.meta.product) {
            const productPrice = window.meta.product.price || window.meta.product.price_min;
            if (productPrice) {
                price = productPrice / 100; // Shopify cents'ten dolara çevir
                debug(`Base price found from Shopify meta: ${price}`);
                return price;
            }
        }

        // Son çare olarak sayfa üzerindeki fiyat elementlerini ara
        const priceSelectors = [
            '.price .money',
            '.product__price .money',
            '.product-price .money',
            '.price-item--regular .money',
            '[data-price]',
            '.current-price'
        ];

        for (const selector of priceSelectors) {
            const priceEl = document.querySelector(selector);
            if (priceEl) {
                const priceText = priceEl.textContent || priceEl.getAttribute('data-price') || '';
                const priceMatch = priceText.match(/[\d.,]+/);
                if (priceMatch) {
                    price = parseFloat(priceMatch[0].replace(/,/g, '')) || 0;
                    if (price > 0) {
                        debug(`Base price found from price element: ${price}`);
                        return price;
                    }
                }
            }
        }

        debug('No base price found, using 0');
        return 0;
    }

    function replaceAddToCartButton(minProduction, groups) {
        debug('Looking for add to cart button to replace');

        const addToCartSelectors = [
            'button[name="add"]',
            '.js-add-to-cart',
            'input[name="add"][type="submit"]',
            '[data-action="add-to-cart"]',
            'button[type="submit"][aria-label*="Add to cart"]',
            'button[type="submit"][aria-label*="add to cart"]',
            '.product-form__cart-submit',
            '.btn--add-to-cart',
            '#AddToCart',
            '#product-add-to-cart',
            'form[action*="/cart/add"] button[type="submit"]:not([name="add"])',
            'product-form button[type="submit"]'
        ];

        let addToCartButton = null;

        for (let selector of addToCartSelectors) {
            addToCartButton = document.querySelector(selector);
            if (addToCartButton && addToCartButton.offsetParent !== null) {
                debug(`Found add to cart button with selector: ${selector}`);
                break;
            }
        }

        if (!addToCartButton) {
            debug('Add to cart button not found, falling back to trigger button');
            const preorderElement = document.querySelector(PREORDER_CONFIG.sourceSelector || '#preorders');
            createTriggerButton(preorderElement, minProduction, groups);
            return;
        }

        originalAddToCartButton = addToCartButton;
        debug('Original add to cart button found:', addToCartButton);

        const replacementButton = addToCartButton.cloneNode(true);
        replacementButton.id = 'preorder-replacement-btn';
        replacementButton.className += ' preorder-replacement-btn';

        const span = replacementButton.querySelector('span');
        if (span) {
            span.textContent = PREORDER_CONFIG.buttonText || 'Pre-Order Now';
        } else {
            replacementButton.innerHTML = replacementButton.innerHTML.replace(
                /Add to cart|Sepete Ekle|Add to Cart/gi,
                PREORDER_CONFIG.buttonText || 'Pre-Order Now'
            );
        }

        replacementButton.setAttribute('aria-label', PREORDER_CONFIG.buttonText || 'Pre-Order Now');
        replacementButton.removeAttribute('name');
        replacementButton.type = 'button';
        replacementButton.removeAttribute('disabled'); // Enable the button

        addToCartButton.parentNode.insertBefore(replacementButton, addToCartButton);
        addToCartButton.classList.add('preorder-add-to-cart-hidden');

        replacementButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            debug('Replacement add to cart button clicked');
            openModal(minProduction, groups);
        });

        debug('Add to cart button successfully replaced');
    }

    function extractMinProduction(element) {
        const pTags = element.querySelectorAll('p');
        for (let p of pTags) {
            if (/Min\s*Üretim\s*Adedi:/i.test(p.textContent || '')) {
                const matches = (p.innerText || '').match(/\d+/g);
                if (matches && matches.length > 0) {
                    const numbers = matches.map(n => parseInt(n, 10));
                    return Math.max(...numbers);
                }
            }
        }
        return 1;
    }

    // Extract set size from ASORTI field (e.g., "1-1-1-1" = 4)
    function extractSetSize(element) {
        const groupElements = element.querySelectorAll('.preorders-group');

        for (let group of groupElements) {
            const titleElement = group.querySelector('strong');
            const title = titleElement ? titleElement.textContent.trim().toUpperCase() : '';

            if (title === 'ASORTI' || title === 'ASSORTMENT') {
                const listItem = group.querySelector('li');
                if (listItem) {
                    const text = listItem.textContent.trim();
                    // Parse format like "1-1-1-1" or "2-2-2-2"
                    const numbers = text.split('-').map(n => parseInt(n.trim(), 10)).filter(n => !isNaN(n));
                    if (numbers.length > 0) {
                        const total = numbers.reduce((sum, n) => sum + n, 0);
                        debug(`[SetSize] ASORTI found: "${text}" = ${total}`);
                        return total > 0 ? total : 1;
                    }
                }
            }
        }

        debug('[SetSize] ASORTI not found, defaulting to 1');
        return 1;
    }

    function extractPreorderGroups(element) {
        const groups = [];
        const groupElements = element.querySelectorAll('.preorders-group');

        groupElements.forEach((group, index) => {
            const titleElement = group.querySelector('strong');
            const title = titleElement ? titleElement.textContent.trim() : `Seçenek ${index + 1}`;

            const listItems = group.querySelectorAll('li');
            const options = [];
            let hasDefault = false;

            Array.from(listItems).forEach(li => {
                const text = li.textContent.trim();
                if (!text) return;

                // Fiyat bilgisini ayıklama: "Var (+0.5 USD)" formatından
                const priceMatch = text.match(/\(([+-]?[\d.]+)\s*USD\)/i);
                const price = priceMatch ? parseFloat(priceMatch[1]) : 0;

                // Label'dan fiyat kısmını temizle
                const label = text.replace(/\s*\([+-]?[\d.]+\s*USD\)/i, '').trim();

                // Default seçenek belirleme (ilk seçenek veya fiyatı 0 olan)
                const isDefault = !hasDefault && (options.length === 0 || price === 0);
                if (isDefault) hasDefault = true;

                options.push({
                    label: label,
                    price: price,
                    isDefault: isDefault
                });
            });

            if (options.length > 0) {
                groups.push({
                    title: title,
                    options: options,
                    id: `preorder-select-${index}`
                });
            }
        });

        return groups;
    }

    function createTriggerButton(preorderElement, minProduction, groups) {
        const buttonText = PREORDER_CONFIG.buttonText || 'Pre-Order Now';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'preorder-trigger-btn';

        button.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17M17 13v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-6M15 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>
      </svg>
      ${buttonText}
    `;

        preorderElement.parentNode.insertBefore(button, preorderElement);

        button.addEventListener('click', () => {
            debug('Trigger button clicked');
            openModal(minProduction, groups);
        });

        debug('Trigger button created with text:', buttonText);
    }

    // Filter payment methods based on customer tags (payment:credit_card, payment:cargo_money_transfer, etc.)
    function filterPaymentMethodsByCustomer() {
        console.log('[Vienetta Payment Filter] Function called');
        try {
            // Get customer data from JSON script
            const customerEl = document.getElementById('preorder-customer-json');
            console.log('[Vienetta Payment Filter] Customer element:', customerEl);
            if (!customerEl) {
                console.log('[Vienetta Payment Filter] Customer JSON element not found');
                debug('[Payment Filter] Customer JSON element not found');
                return;
            }

            const customerData = JSON.parse(customerEl.textContent);
            console.log('[Vienetta Payment Filter] Customer data:', customerData);
            if (!customerData) {
                console.log('[Vienetta Payment Filter] No customer data - showing all payment methods');
                debug('[Payment Filter] No customer data - showing all payment methods');
                return;
            }

            // Parse allowed_payments from customer tags
            // Tags format: ['3.Grup', 'payment:credit_card', 'payment:bank_transfer_eft']
            const tags = customerData.tags || [];
            console.log('[Vienetta Payment Filter] Customer tags:', tags);

            // Extract payment methods from tags (payment:xxx format)
            let allowedPayments = [];
            if (Array.isArray(tags)) {
                allowedPayments = tags
                    .filter(t => t.startsWith('payment:'))
                    .map(t => t.replace('payment:', ''));
            } else if (typeof tags === 'string') {
                // If tags come as comma-separated string
                allowedPayments = tags.split(',')
                    .map(t => t.trim())
                    .filter(t => t.startsWith('payment:'))
                    .map(t => t.replace('payment:', ''));
            }

            console.log('[Vienetta Payment Filter] Allowed payments:', allowedPayments);
            debug('[Payment Filter] Customer tags:', tags);
            debug('[Payment Filter] Allowed payments:', allowedPayments);

            // If no restrictions, show all payment methods
            if (allowedPayments.length === 0) {
                debug('[Payment Filter] No restrictions - showing all payment methods');
                return;
            }

            // Get all payment method radio buttons
            const paymentRadios = document.querySelectorAll('.preorder-payment-radio');

            paymentRadios.forEach(radio => {
                const paymentValue = radio.value;
                const parentLabel = radio.closest('.preorder-payment-option');

                if (allowedPayments.includes(paymentValue)) {
                    // Show this payment method
                    if (parentLabel) {
                        parentLabel.style.display = '';
                    }
                    debug(`[Payment Filter] Showing: ${paymentValue}`);
                } else {
                    // Hide this payment method
                    if (parentLabel) {
                        parentLabel.style.display = 'none';
                    }
                    // Also uncheck if it was checked
                    radio.checked = false;
                    debug(`[Payment Filter] Hiding: ${paymentValue}`);
                }
            });

            // Auto-select first available payment method if only one is available
            const visibleRadios = Array.from(paymentRadios).filter(r => {
                const parent = r.closest('.preorder-payment-option');
                return parent && parent.style.display !== 'none';
            });

            if (visibleRadios.length === 1) {
                visibleRadios[0].checked = true;
                debug('[Payment Filter] Auto-selected single available method:', visibleRadios[0].value);
            }

            debug(`[Payment Filter] Filtered: ${visibleRadios.length} payment method(s) available`);

        } catch (error) {
            console.error('[Payment Filter] Error filtering payment methods:', error);
            debug('[Payment Filter] Error: ' + error.message);
        }
    }

    /**
     * Load fabric options from API and populate dropdown
     * @param {string} stokkodu - Product SKU code
     */
    async function loadFabricOptions(stokkodu) {
        const fabricField = document.getElementById('preorder-fabric-field');
        const fabricSelect = document.getElementById('preorder-fabric');

        if (!fabricField || !fabricSelect) {
            debug('[Fabric] Fabric field or select not found');
            return;
        }

        // Hide by default
        fabricField.style.display = 'none';

        if (!stokkodu) {
            debug('[Fabric] No stokkodu provided');
            return;
        }

        try {
            const apiUrl = (PREORDER_CONFIG.apiUrl || 'https://patronundan.com/preorders') + `/products/${encodeURIComponent(stokkodu)}/fabrics`;
            debug(`[Fabric] Fetching fabric options from: ${apiUrl}`);

            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (!response.ok) {
                debug(`[Fabric] API response not OK: ${response.status}`);
                return;
            }

            const data = await response.json();
            debug('[Fabric] API response:', data);

            if (data.ok && data.fabric_options && data.fabric_options.length > 0) {
                // Clear existing options except the first placeholder
                fabricSelect.innerHTML = '<option value="">Seçiniz...</option>';

                // Add fabric options
                data.fabric_options.forEach(fabric => {
                    const option = document.createElement('option');
                    option.value = fabric;
                    option.textContent = fabric;
                    fabricSelect.appendChild(option);
                });

                // Show the field
                fabricField.style.display = 'block';
                debug(`[Fabric] Loaded ${data.fabric_options.length} fabric options`);

                // Add change event listener for Private Label mode
                fabricSelect.addEventListener('change', function() {
                    if (this.value) {
                        switchToPrivateLabelMode();
                    } else {
                        switchToPreorderMode();
                    }
                });
            } else {
                debug('[Fabric] No fabric options available for this product');
            }
        } catch (error) {
            console.error('[Fabric] Error loading fabric options:', error);
            debug('[Fabric] Error: ' + error.message);
        }
    }

    /**
     * Switch to Private Label mode when fabric is selected
     * - Hides price display
     * - Hides payment method section
     * - Changes button text to "Request"
     * - Hides progress bar
     */
    function switchToPrivateLabelMode() {
        debug('[Private Label] Switching to Private Label mode');

        // Hide price display
        const priceDisplay = document.getElementById('preorder-price-display');
        if (priceDisplay) priceDisplay.style.display = 'none';

        // Hide payment method section
        const paymentSection = document.querySelector('.preorder-payment-methods')?.closest('.preorder-form-field');
        if (paymentSection) paymentSection.style.display = 'none';

        // Change button text to "Request"
        const submitBtn = document.querySelector('.preorder-btn-submit');
        if (submitBtn) {
            submitBtn.textContent = 'Talep Gönder';
            submitBtn.dataset.mode = 'private_label';
        }

        // Hide progress bar (no progress tracking for private label)
        const progressBar = document.getElementById('preorder-option-progress');
        if (progressBar) progressBar.style.display = 'none';

        debug('[Private Label] Mode activated');
    }

    /**
     * Switch back to normal Preorder mode when fabric is deselected
     */
    function switchToPreorderMode() {
        debug('[Private Label] Switching back to Preorder mode');

        // Show price display
        const priceDisplay = document.getElementById('preorder-price-display');
        if (priceDisplay) priceDisplay.style.display = 'block';

        // Show payment method section
        const paymentSection = document.querySelector('.preorder-payment-methods')?.closest('.preorder-form-field');
        if (paymentSection) paymentSection.style.display = 'block';

        // Restore button text
        const submitBtn = document.querySelector('.preorder-btn-submit');
        if (submitBtn) {
            submitBtn.textContent = PREORDER_CONFIG.buttonText || 'Pre-Order Now';
            submitBtn.dataset.mode = 'preorder';
        }

        // Show progress bar
        const progressBar = document.getElementById('preorder-option-progress');
        if (progressBar) progressBar.style.display = 'block';

        debug('[Private Label] Mode deactivated');
    }

    function openModal(minProduction, groups) {
        debug(`Opening modal with ${groups.length} groups`);

        // Remove any existing progress bars from product page
        const existingProgressBars = document.querySelectorAll('.variant-progress-main-container, .variant-progress-container, .preorder-progress-container, #preorder-progress-bar');
        existingProgressBars.forEach(bar => bar.remove());
        debug('[Progress] Removed existing progress bars from product page');

        const backdrop = document.getElementById('preorder-modal-backdrop');
        const minInfo = document.getElementById('preorder-min-info');
        const dynamicFields = document.getElementById('preorder-dynamic-fields');
        const quantityInput = document.getElementById('preorder-quantity');

        // Payment method handling (card country selection removed - only international customers)

        // Configure quantity input with set size (ASORTI)
        quantityInput.min = setSize;
        quantityInput.step = setSize;
        quantityInput.value = setSize;
        debug(`[SetSize] Quantity input configured: min=${setSize}, step=${setSize}`);

        // Show set size info if > 1
        let setSizeInfo = '';
        if (setSize > 1) {
            setSizeInfo = `<br><strong>Set size: ${setSize} units</strong> (Quantity must be multiples of ${setSize})`;
        }

        minInfo.innerHTML = `
      <strong>Minimum üretim adedi: ${minProduction}</strong><br>
      Production starts when the total reaches this number.${setSizeInfo}
    `;

        // Fiyat display'ini başlat
        currentPrice = basePrice;
        updatePrice();

        // Varyant select'lerini oluştur (popup açılırken)
        console.log('[Vienetta] Creating variant selects in modal...');
        createVariantSelects();
        console.log('[Vienetta] Variant selects creation completed');

        // Başlangıç variant ID'sini ayarla ve variant mapping'i oluştur
        const initialVariantId = getCurrentVariantId();
        const modal = document.getElementById('preorder-modal');
        if (modal && initialVariantId) {
            modal.setAttribute('data-current-variant-id', initialVariantId);
            debug(`Set initial variant ID in modal: ${initialVariantId}`);
        }

        // Variant mapping oluştur (variant isimlerinden ID'lere)
        if (window.meta && window.meta.product && window.meta.product.variants) {
            const variantMap = {};
            window.meta.product.variants.forEach(v => {
                if (v.option1) {
                    variantMap[v.option1] = v.id;
                    debug(`Variant mapping: ${v.option1} -> ${v.id}`);
                }
            });
            // Map'i global olarak sakla
            window.preorderVariantMap = variantMap;

            // Debug: Show available variants
            debug('Available variants for this product:');
            window.meta.product.variants.forEach(v => {
                debug(`  - ${v.option1}: ID = ${v.id}, SKU = ${v.sku}, Available = ${v.available}`);
            });
        }

        dynamicFields.innerHTML = '';
        groups.forEach((group, index) => {
            const fieldDiv = document.createElement('div');
            fieldDiv.className = 'preorder-form-field';

            const label = document.createElement('label');
            label.className = 'preorder-form-label';
            label.textContent = translateLabel(group.title); // Display in English
            label.setAttribute('for', group.id);

            const select = document.createElement('select');
            select.id = group.id;
            select.className = 'preorder-form-select notranslate';
            select.name = group.title;
            select.required = true;
            select.setAttribute('translate', 'no'); // Weglot/translation tools bypass

            const defaultOption = document.createElement('option');
            defaultOption.value = '';
            defaultOption.textContent = 'Seçiniz...';
            defaultOption.disabled = true;
            defaultOption.selected = true;
            select.appendChild(defaultOption);

            let defaultSelected = false;

            group.options.forEach((option, optIndex) => {
                const optionElement = document.createElement('option');
                optionElement.value = option.label;
                optionElement.dataset.price = option.price.toString();
                optionElement.dataset.originalText = option.label;
                optionElement.dataset.translatedText = translateLabel(option.label); // Cache translated text
                optionElement.dataset.isDefault = option.isDefault ? 'true' : 'false'; // Default bilgisini sakla
                optionElement.setAttribute('translate', 'no'); // Prevent external translation tools
                optionElement.className = 'notranslate';

                // Option label'ini cevir
                let translatedLabel = translateLabel(option.label);
                let optionText = translatedLabel;
                if (option.price > 0) {
                    optionText += ` (+${option.price.toFixed(2)})`;
                } else if (option.price < 0) {
                    optionText += ` (${option.price.toFixed(2)})`;
                }

                optionElement.textContent = optionText;

                // Default seçenek varsa seç
                if (option.isDefault && !defaultSelected) {
                    optionElement.selected = true;
                    defaultOption.selected = false;
                    defaultSelected = true;
                }

                select.appendChild(optionElement);
            });

            // Wrapper div'i select için oluştur
            const selectWrapper = document.createElement('div');
            selectWrapper.className = 'preorder-select-wrapper';
            selectWrapper.appendChild(select);

            // Fiyat değişikliklerini dinle
            select.addEventListener('change', calculatePrice);

            fieldDiv.appendChild(label);
            fieldDiv.appendChild(selectWrapper);
            dynamicFields.appendChild(fieldDiv);
        });

        // İlk fiyat hesaplaması
        setTimeout(calculatePrice, 100);

        // Quantity input'a event listener ekle
        quantityInput.addEventListener('input', updatePrice);
        quantityInput.addEventListener('change', updatePrice);

        // Round quantity to nearest valid multiple on blur (when user finishes typing)
        quantityInput.addEventListener('blur', function() {
            if (setSize <= 1) return; // No rounding needed

            const value = parseInt(this.value, 10);
            if (isNaN(value) || value < setSize) {
                this.value = setSize;
                showError(`Quantity must be at least ${setSize} units. Set to minimum.`);
                setTimeout(clearError, 3000);
                updatePrice();
                return;
            }

            const remainder = value % setSize;
            if (remainder !== 0) {
                // Round to nearest multiple
                const lowerMultiple = value - remainder;
                const upperMultiple = lowerMultiple + setSize;
                // Choose the nearest one (prefer lower if equal distance)
                const nearestMultiple = (value - lowerMultiple) <= (upperMultiple - value) ? lowerMultiple : upperMultiple;

                this.value = nearestMultiple;
                showError(`Quantity adjusted to ${nearestMultiple}. Must be a multiple of ${setSize} (set size).`);
                setTimeout(clearError, 3000);
                updatePrice();
            }
        });

        // Varyant değişikliklerini dinle ve log'la
        document.querySelectorAll('#preorder-variant-fields input[type="radio"]').forEach(radio => {
            radio.addEventListener('change', function() {
                debug(`Variant changed to: ${this.value}`);
                // Variant ID'yi güncelle
                setTimeout(() => {
                    const newVariantId = getCurrentVariantId();
                    debug(`Updated variant ID: ${newVariantId}`);
                }, 100);
            });
        });

        backdrop.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Filter payment methods based on customer note
        filterPaymentMethodsByCustomer();

        // Load fabric options for this product
        const productCodes = parseProductCodes();
        if (productCodes && productCodes.barcode) {
            loadFabricOptions(productCodes.barcode);
        }

        setTimeout(() => {
            quantityInput.focus();
            quantityInput.value = setSize; // Start with minimum valid quantity
        }, 100);

        setupModalEvents(minProduction);

        // Progress bar icin listener'lari ekle ve ilk fetch'i yap
        setTimeout(() => {
            attachProgressListeners();
            // Ilk progress fetch'i yap (eger secimler varsa)
            fetchOptionProgress();
        }, 200);

        debug('Modal opened');
    }

    function setupModalEvents(minProduction) {
        const backdrop = document.getElementById('preorder-modal-backdrop');
        const closeBtn = document.getElementById('preorder-close-btn');
        const cancelBtn = document.getElementById('preorder-cancel-btn');
        const form = document.getElementById('preorder-form');
        const submitBtn = document.querySelector('.preorder-btn-submit');

        const closeModal = () => {
            debug('Closing modal');
            backdrop.classList.remove('active');
            document.body.style.overflow = '';
            clearError();
            form.reset();
            submitBtn.disabled = false;
            submitBtn.textContent = PREORDER_CONFIG.buttonText || 'Pre-Order Now';
            currentPrice = basePrice;
            updatePrice();
        };

        closeBtn.replaceWith(closeBtn.cloneNode(true));
        document.getElementById('preorder-close-btn').addEventListener('click', closeModal);

        cancelBtn.replaceWith(cancelBtn.cloneNode(true));
        document.getElementById('preorder-cancel-btn').addEventListener('click', closeModal);

        backdrop.onclick = (e) => {
            if (e.target === backdrop) {
                closeModal();
            }
        };

        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
        };
        document.addEventListener('keydown', handleEscape);

        form.onsubmit = (e) => {
            e.preventDefault();
            handleFormSubmit(minProduction, closeModal, submitBtn);
        };
    }

    // İyzico Kredi Kartı Ödeme İşleme Fonksiyonu
    async function handleCreditCardPayment(quantity, note, packaging, shipping, selections, variantId, variantName, productInfo, customerInfo, minProduction, closeModal, submitBtn, agreementCheckbox) {
        try {
            debug('Starting credit card payment flow - USD only for international customers');

            // Toplam tutarı hesapla (currentPrice zaten seçeneklere göre güncellendi)
            const totalAmount = currentPrice * quantity;

            // Preorder data hazırla
            const preorderData = {
                timestamp: new Date().toISOString(),
                product: productInfo,
                variant_id: variantId,
                variant_name: variantName,
                quantity: quantity,
                min_production: minProduction,
                selections: selections,
                note: note,
                packaging_request: packaging,
                shipping_info: shipping,
                payment_method: 'credit_card',
                base_price: basePrice,
                total_price: currentPrice,
                unit_price: currentPrice,
                total_amount: totalAmount,
                customer_info: customerInfo,
                agreement_accepted: agreementCheckbox.checked,
                shopify_data: {
                    shop: window.Shopify?.shop || '',
                    currency: window.Shopify?.currency?.active || 'USD',
                    country: window.Shopify?.country || 'TR'
                },
                status: 'pending',
                order_type: 'preorder',
                source: 'shopify_theme_extension'
            };

            // Müşteri bilgilerini hazırla
            const buyer = customerInfo.logged_in ? {
                id: 'BY_' + customerInfo.id,
                name: customerInfo.first_name || 'Müşteri',
                surname: customerInfo.last_name || 'Adı',
                gsmNumber: customerInfo.phone || '+905350000000',
                email: customerInfo.email || 'customer@email.com',
                identityNumber: '11111111111',
                registrationAddress: 'Adres Bilgisi',
                city: 'Istanbul',
                country: 'Turkey',
                zipCode: '34000'
            } : null;

            // İyzico initialize request
            const initializeData = {
                preorderData: preorderData,
                buyer: buyer
            };

            debug('Sending initialize request to iyzico...', initializeData);

            // Kur bilgilendirmesi göster (USD ise)
            const shopifyCurrency = window.Shopify?.currency?.active || 'USD';
            if (shopifyCurrency === 'USD' || shopifyCurrency === 'EUR' || shopifyCurrency === 'GBP') {
                const currencyNames = { USD: 'Dolar', EUR: 'Euro', GBP: 'Sterlin' };
                submitBtn.textContent = `Converting ${currencyNames[shopifyCurrency]} payment...`;
            } else {
                submitBtn.textContent = 'Preparing payment page...';
            }

            // İyzico initialize endpoint'ine istek at
            const response = await fetch('https://patronundan.com/vienetta-iyzico/initialize', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(initializeData)
            });

            const result = await response.json();

            if (!result.ok || !result.paymentPageUrl) {
                throw new Error(result.error || 'Could not create payment page');
            }

            debug('Payment page URL received:', result.paymentPageUrl);

            // Popup window aç
            const paymentWindow = window.open(
                result.paymentPageUrl,
                'IyzicoPayment',
                'width=800,height=600,scrollbars=yes,resizable=yes'
            );

            if (!paymentWindow) {
                throw new Error('Could not open popup window. Please disable your popup blocker.');
            }

            submitBtn.textContent = 'Waiting for payment...';

            // Popup'tan gelen mesajları dinle
            const messageHandler = (event) => {
                // Güvenlik için origin kontrolü
                if (!event.origin.includes('patronundan.com') && !event.origin.includes('iyzipay.com')) {
                    return;
                }

                debug('Message received from payment window:', event.data);

                if (event.data.type === 'PAYMENT_SUCCESS') {
                    debug('Payment successful!');
                    window.removeEventListener('message', messageHandler);

                    closeModal();

                    showSuccessNotification('Payment successful! Order details will be sent to your email.');

                } else if (event.data.type === 'PAYMENT_ERROR') {
                    debug('Payment failed:', event.data.error);
                    window.removeEventListener('message', messageHandler);

                    resetSubmitButton(submitBtn);
                    showError(`Payment failed: ${event.data.error || 'Unknown error'}`);
                }
            };

            window.addEventListener('message', messageHandler);

            // Popup kapanırsa kontrol et - ama önce backend'den status kontrol et
            let paymentCompleted = false;
            const checkWindowClosed = setInterval(async () => {
                if (paymentWindow.closed && !paymentCompleted) {
                    clearInterval(checkWindowClosed);

                    debug('Payment window closed by user, checking status...');
                    submitBtn.textContent = 'Checking payment status...';

                    // Backend'den son durumu sorgula
                    try {
                        const statusResponse = await fetch(`https://patronundan.com/vienetta-iyzico/status/${result.token}`);
                        const statusData = await statusResponse.json();

                        debug('Payment status:', statusData);

                        if (statusData.ok && statusData.status === 'completed') {
                            // Ödeme tamamlanmış!
                            paymentCompleted = true;
                            window.removeEventListener('message', messageHandler);

                            closeModal();
                            showSuccessNotification('Payment successful! Order details will be sent to your email.');
                        } else {
                            // Ödeme tamamlanmamış
                            window.removeEventListener('message', messageHandler);
                            resetSubmitButton(submitBtn);

                            // Daha dostça bir mesaj
                            const confirmRetry = confirm(
                                'You did not complete the payment.\n\n' +
                                'Would you like to try again?'
                            );

                            if (confirmRetry) {
                                // Formu tekrar submit et (aynı verilerle)
                                submitBtn.textContent = 'Preparing payment page...';
                                await handleCreditCardPayment(quantity, note, shipping, selections, variantId, productInfo, customerInfo, minProduction, closeModal, submitBtn, agreementCheckbox);
                            }
                        }
                    } catch (error) {
                        debug('Status check error:', error);
                        window.removeEventListener('message', messageHandler);
                        resetSubmitButton(submitBtn);
                        showError('Could not check payment status. Please contact customer service.');
                    }
                }
            }, 2000); // 2 saniyede bir kontrol et

        } catch (error) {
            console.error('Credit card payment error:', error);
            debug(`Credit card payment error: ${error.message}`);
            showError(`Payment error: ${error.message}`);
            resetSubmitButton(submitBtn);
        }
    }

    // API'ye veri gönderme fonksiyonu - MongoDB yerine
    async function sendToAPI(formData) {
        if (!PREORDER_CONFIG.apiUrl) {
            debug('API URL not configured');
            return { success: false, error: 'API URL not configured' };
        }

        try {
            debug('Sending data to API', formData);

            const timeout = PREORDER_CONFIG.apiTimeout || 30000;

            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), timeout);

            const response = await fetch(PREORDER_CONFIG.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(formData),
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            if (!response.ok) {
                throw new Error(`API response error: ${response.status} ${response.statusText}`);
            }

            const result = await response.json();
            debug('API save successful', result);

            return { success: true, data: result };

        } catch (error) {
            console.error('API save error:', error);
            debug(`API save error: ${error.message}`);

            let errorMessage = error.message;
            if (error.name === 'AbortError') {
                errorMessage = 'Request timeout - API response took too long';
            } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
                errorMessage = 'Network error - could not connect to API';
            }

            return { success: false, error: errorMessage };
        }
    }

    async function handleFormSubmit(minProduction, closeModal, submitBtn) {
        debug('Form submission started');
        clearError();

        submitBtn.disabled = true;
        submitBtn.textContent = 'İşleniyor...';

        const quantityInput = document.getElementById('preorder-quantity');
        const noteInput = document.getElementById('preorder-note');
        const packagingInput = document.getElementById('preorder-packaging');
        const shippingInput = document.getElementById('preorder-shipping');
        const agreementCheckbox = document.getElementById('preorder-agreement');
        const paymentMethodRadios = document.querySelectorAll('input[name="payment_method"]:checked');

        const quantity = parseInt(quantityInput.value, 10);
        const note = noteInput.value.trim();
        const packaging = packagingInput ? packagingInput.value.trim() : '';
        const shipping = shippingInput.value.trim();
        const paymentMethod = paymentMethodRadios.length > 0 ? paymentMethodRadios[0].value : '';

        // Validasyonlar
        if (!quantity || quantity < 1) {
            showError('Lütfen geçerli bir adet giriniz.');
            resetSubmitButton(submitBtn);
            return;
        }

        if (quantity > 100000) {
            showError('Maksimum sipariş adedi 100.000 adettir.');
            resetSubmitButton(submitBtn);
            return;
        }

        // Validate quantity is a multiple of set size (ASORTI)
        if (setSize > 1) {
            if (quantity < setSize) {
                showError(`Adet en az ${setSize} olmalıdır (asorti/set adedi).`);
                resetSubmitButton(submitBtn);
                return;
            }
            if (quantity % setSize !== 0) {
                const lowerMultiple = quantity - (quantity % setSize);
                const upperMultiple = lowerMultiple + setSize;
                showError(`Adet ${setSize}'in katı olmalıdır (asorti/set adedi). Lütfen ${lowerMultiple} veya ${upperMultiple} giriniz.`);
                resetSubmitButton(submitBtn);
                return;
            }
        }

        // Check if this is a Private Label request (fabric selected)
        const fabricSelectForValidation = document.getElementById('preorder-fabric');
        const fabricFieldForValidation = document.getElementById('preorder-fabric-field');
        const isPrivateLabelRequest = fabricSelectForValidation &&
                                      fabricFieldForValidation &&
                                      fabricFieldForValidation.style.display !== 'none' &&
                                      fabricSelectForValidation.value;

        // Payment method validation - skip for Private Label requests
        if (!isPrivateLabelRequest && !paymentMethod) {
            showError('Lütfen bir ödeme yöntemi seçiniz.');
            resetSubmitButton(submitBtn);
            return;
        }

        if (!agreementCheckbox.checked) {
            showError('Lütfen ön sipariş bilgilendirme metnini okuyup kabul ediniz.');
            resetSubmitButton(submitBtn);
            return;
        }

        debug(`Quantity: ${quantity}, Note: ${note}, Shipping: ${shipping}, Payment Method: ${paymentMethod}, Total Price: ${currentPrice.toFixed(2)}`);

        const selections = {};

        // 1. Preorder options (dinamik alanlar) - Malzeme seçenekleri vs.
        const preorderSelects = document.querySelectorAll('#preorder-dynamic-fields select');
        for (let select of preorderSelects) {
            if (!select.value) {
                showError('Lütfen tüm ön sipariş seçeneklerini belirleyiniz.');
                resetSubmitButton(submitBtn);
                return;
            }

            // Seçilen option'ın default olup olmadığını kontrol et
            const selectedOption = select.options[select.selectedIndex];
            const isDefault = selectedOption?.dataset?.isDefault === 'true';
            let value = select.value;

            // Default değilse "(Değiştirildi)" etiketi ekle
            if (!isDefault) {
                value += ' (Değiştirildi)';
            }

            selections[select.name] = value;
        }

        // 2. Varyant seçenekleri (popup'taki varyant select'leri) - Renk, Beden, Material vs.
        const variantSelects = document.querySelectorAll('#preorder-variant-fields select');
        for (let select of variantSelects) {
            if (!select.value) {
                showError(`Lütfen "${select.name}" seçeneğini belirleyiniz.`);
                resetSubmitButton(submitBtn);
                return;
            }
            selections[select.name] = select.value;
        }

        // 3. Fabric option (kumaş seçeneği) - opsiyonel
        const fabricSelect = document.getElementById('preorder-fabric');
        const fabricField = document.getElementById('preorder-fabric-field');
        if (fabricSelect && fabricField && fabricField.style.display !== 'none' && fabricSelect.value) {
            selections['Fabric Option'] = fabricSelect.value;
            debug(`[Fabric] Selected fabric: ${fabricSelect.value}`);
        }

        debug('Selections collected (preorder options + variants)', selections);

        const variantId = getCurrentVariantId();
        if (!variantId) {
            showError('Ürün varyantı bulunamadı.');
            resetSubmitButton(submitBtn);
            return;
        }

        debug(`Variant ID: ${variantId}`);

        // Varyant ismini selections'tan al
        let variantName = '';
        if (selections['Varyant']) {
            variantName = selections['Varyant'];
        } else if (selections['Variant']) {
            variantName = selections['Variant'];
        }
        debug(`Variant Name: ${variantName}`);

        const productInfo = getProductInfo();
        debug('Product info collected', productInfo);

        // Ürün kodlarını ekle
        const productCodes = parseProductCodes();
        if (productCodes) {
            productInfo.codes = productCodes;
            debug('Product codes added to product info', productCodes);
        }

        const customerInfo = getCustomerInfo();
        debug('Customer info collected', customerInfo);

        // Kredi kartı seçiliyse iyzico akışına yönlendir (Private Label hariç)
        // KZK: enableCreditCard === false ise iyzico tetiklenmez; kredi karti yalnizca odeme yontemi olarak kaydedilir
        if (!isPrivateLabelRequest && paymentMethod === 'credit_card' && PREORDER_CONFIG.enableCreditCard !== false) {
            debug('Credit card payment selected, redirecting to iyzico...');
            await handleCreditCardPayment(quantity, note, packaging, shipping, selections, variantId, variantName, productInfo, customerInfo, minProduction, closeModal, submitBtn, agreementCheckbox);
            return;
        }

        // API'ye gönderilecek veri (KZK backend tarafinda brand=kzk olarak kaydedilsin)
        const apiData = {
            timestamp: new Date().toISOString(),
            brand: PREORDER_CONFIG.brand || 'kzk',
            product: productInfo,
            variant_id: variantId,
            variant_name: variantName,
            quantity: quantity,
            min_production: minProduction,
            selections: selections,
            note: note,
            packaging_request: packaging,
            shipping_info: shipping,
            payment_method: paymentMethod,
            base_price: basePrice,
            total_price: currentPrice,
            unit_price: currentPrice,
            total_amount: currentPrice * quantity,
            customer_info: customerInfo,
            agreement_accepted: agreementCheckbox.checked,
            shopify_data: {
                shop: window.Shopify?.shop || '',
                currency: window.Shopify?.currency?.active || '',
                country: window.Shopify?.country || ''
            },
            status: 'pending',
            order_type: 'preorder',
            source: 'kzk_theme'
        };

        // Private Label request - override values
        if (isPrivateLabelRequest) {
            apiData.order_type = 'private_label';
            apiData.payment_method = 'request_only';
            apiData.base_price = 0;
            apiData.unit_price = 0;
            apiData.total_price = 0;
            apiData.total_amount = 0;
            apiData.fabric_option = fabricSelectForValidation.value;
            debug('[Private Label] Request data modified for private label submission');
        }

        debug('API data prepared', apiData);

        // API'ye gönder
        const apiResult = await sendToAPI(apiData);
        debug('API result:', apiResult);

        if (apiResult.success) {
            debug(`Successfully sent to API with response:`, apiResult.data);

            // Kişisel "Talebiniz Alındı" rozeti cache'ini temizle (yeni ön sipariş hemen görünsün)
            try {
                var _rbEmail = String((customerInfo && customerInfo.email) || '').trim().toLowerCase();
                if (_rbEmail) sessionStorage.removeItem('kzk_ontalep_handles_' + _rbEmail);
            } catch (e) {}

            closeModal();

            const referenceId = apiResult.data.insertedId || apiResult.data.id || 'UNKNOWN';

            // Private label için farklı mesaj göster
            if (isPrivateLabelRequest) {
                showSuccessNotification('Talebiniz alındı! Fiyat detayları için sizinle iletişime geçeceğiz.');
            } else {
                showSuccessNotification('Ön siparişiniz alındı! E-postanıza onay gönderilecektir.');
            }

            if (PREORDER_CONFIG.redirectToThankYou) {
                setTimeout(() => {
                    window.location.href = `/pages/preorder-thank-you?ref=${referenceId}`;
                }, 3000);
            }

        } else {
            console.error('API save error:', apiResult.error);
            debug(`API error: ${apiResult.error}`);
            showError(`Hata: ${apiResult.error}`);
            resetSubmitButton(submitBtn);
        }
    }

    function resetSubmitButton(submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = PREORDER_CONFIG.buttonText || 'Ön Sipariş Ver';
    }

    function getProductInfo() {
        const productInfo = {
            id: null,
            title: '',
            handle: '',
            url: window.location.href
        };

        if (window.meta && window.meta.product) {
            productInfo.id = window.meta.product.id;
            productInfo.title = window.meta.product.title;
            productInfo.handle = window.meta.product.handle;
        } else if (window.product) {
            productInfo.id = window.product.id;
            productInfo.title = window.product.title;
            productInfo.handle = window.product.handle;
        }

        if (!productInfo.title) {
            const titleElement = document.querySelector('h1, .product-title, .product__title');
            if (titleElement) {
                productInfo.title = titleElement.textContent.trim();
            }
        }

        // Handle fallback - URL veya DOM'dan al
        if (!productInfo.handle) {
            // Strateji 1: variant-options elementinden al
            const variantOptions = document.querySelector('variant-options');
            if (variantOptions) {
                productInfo.handle = variantOptions.getAttribute('data-product-handle') ||
                                   variantOptions.getAttribute('data-url')?.split('/').pop();
            }

            // Strateji 2: URL pathname'den al
            if (!productInfo.handle) {
                const pathMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
                if (pathMatch) {
                    productInfo.handle = pathMatch[1];
                }
            }
        }

        return productInfo;
    }

    function findCustomerGroup(customerData) {
        // Müşteri tag'lerini kontrol et
        // Shopify'da customer.tags array'i var
        if (!customerData || !customerData.logged_in) {
            return null;
        }

        // Preorder customer JSON'dan tags al
        const el = document.getElementById('preorder-customer-json');
        if (el) {
            try {
                const raw = el.textContent?.trim() || 'null';
                if (raw !== 'null' && raw !== '') {
                    const customerObj = JSON.parse(raw);

                    // Eğer tags varsa
                    if (customerObj && customerObj.tags) {
                        // Tags string veya array olabilir
                        const tags = Array.isArray(customerObj.tags)
                            ? customerObj.tags
                            : String(customerObj.tags).split(',').map(t => t.trim());

                        debug('Customer tags:', tags);

                        // 1.Grup, 2.Grup, 3.Grup, 4.Grup, 5.Grup, 6.Grup formatını ara
                        const groupPatterns = ['1.Grup', '2.Grup', '3.Grup', '4.Grup', '5.Grup', '6.Grup'];

                        for (const pattern of groupPatterns) {
                            for (const tag of tags) {
                                if (String(tag).includes(pattern)) {
                                    debug(`Found matching group tag: ${tag} -> ${pattern}`);
                                    return pattern;
                                }
                            }
                        }
                    }
                }
            } catch (e) {
                debug('Error parsing customer tags:', e);
            }
        }

        return null;
    }

    function getCustomerInfo() {
        try {
            // Method 0: KZK Custom Auth oturumu (kzk-auth.js -> window.customerData)
            // Shopify müşteri hesapları kullanılmadığı için birincil kaynak budur.
            if (window.customerData && window.customerData.email) {
                const cd = window.customerData;
                debug('Customer data from KZK auth session:', cd.email);
                return {
                    logged_in: true,
                    id: cd.id || null,
                    email: cd.email,
                    first_name: cd.name || null,
                    last_name: null,
                    phone: cd.phone || null,
                    accepts_marketing: false,
                    orders_count: 0,
                    total_spent: '0',
                    tags: cd.tags || [],
                    source: 'kzk_auth'
                };
            }

            // Method 1: Preorder customer JSON element
            const el = document.getElementById('preorder-customer-json');
            if (el) {
                const raw = el.textContent?.trim() || 'null';
                debug('Raw customer data from element:', raw);

                if (raw !== 'null' && raw !== '' && !raw.includes('error')) {
                    const c = JSON.parse(raw);
                    if (c && !c.error && c.id) {
                        debug('Customer data from element successful:', c);
                        return {
                            logged_in: true,
                            id: c.id,
                            email: c.email || null,
                            first_name: c.first_name || null,
                            last_name: c.last_name || null,
                            phone: c.phone || null,
                            accepts_marketing: c.accepts_marketing || false,
                            orders_count: c.orders_count || 0,
                            total_spent: c.total_spent || '0',
                            tags: c.tags || []
                        };
                    }
                }
            }

            // Method 2: Shopify meta customer object
            if (window.meta && window.meta.page && window.meta.page.customerId) {
                debug('Customer data from window.meta');
                return {
                    logged_in: true,
                    id: window.meta.page.customerId,
                    email: null,
                    first_name: null,
                    last_name: null,
                    phone: null,
                    accepts_marketing: false,
                    orders_count: 0,
                    total_spent: '0',
                    source: 'meta'
                };
            }

            // Method 3: Shopify customer object (if available)
            if (window.customer && window.customer.id) {
                debug('Customer data from window.customer');
                return {
                    logged_in: true,
                    id: window.customer.id,
                    email: window.customer.email || null,
                    first_name: window.customer.first_name || null,
                    last_name: window.customer.last_name || null,
                    phone: window.customer.phone || null,
                    accepts_marketing: window.customer.accepts_marketing || false,
                    orders_count: window.customer.orders_count || 0,
                    total_spent: window.customer.total_spent || '0',
                    source: 'window_customer'
                };
            }

            // Method 4: Check for Shopify.customer
            if (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) {
                debug('Customer data from Shopify.customer');
                return {
                    logged_in: true,
                    id: window.Shopify.customer.id,
                    email: window.Shopify.customer.email || null,
                    first_name: window.Shopify.customer.first_name || null,
                    last_name: window.Shopify.customer.last_name || null,
                    phone: window.Shopify.customer.phone || null,
                    accepts_marketing: window.Shopify.customer.accepts_marketing || false,
                    orders_count: 0,
                    total_spent: '0',
                    source: 'shopify_customer'
                };
            }

            debug('No customer data found (user not logged in)');
            return {
                logged_in: false,
                id: null,
                email: null,
                first_name: null,
                last_name: null,
                phone: null
            };

        } catch (e) {
            console.error('Customer info error:', e);
            debug(`Customer info error: ${e.message}`);
            return {
                logged_in: false,
                id: null,
                email: null,
                first_name: null,
                last_name: null,
                phone: null,
                error: e.message
            };
        }
    }

    function getCurrentVariantId() {
        // ÖNCE modal'da saklanan variant ID'yi kontrol et (popup'tan seçim yapıldıysa)
        const modal = document.getElementById('preorder-modal');
        if (modal) {
            const modalVariantId = modal.getAttribute('data-current-variant-id');
            if (modalVariantId) {
                const id = parseInt(modalVariantId, 10);
                if (Number.isInteger(id) && id > 0) {
                    debug(`Found variant ID from modal data-current-variant-id: ${id}`);
                    return id;
                }
            }
        }

        // variant-options elementinden al
        const variantOptionsEl = document.querySelector('variant-options');
        if (variantOptionsEl) {
            const dataVariantId = variantOptionsEl.getAttribute('data-variant-id');
            if (dataVariantId) {
                const id = parseInt(dataVariantId, 10);
                if (Number.isInteger(id) && id > 0) {
                    debug(`Found variant ID from variant-options data-variant-id: ${id}`);
                    return id;
                }
            }
        }

        // Input'lardan al
        const selectors = [
            'form[action*="/cart/add"] input[name="id"]:not([disabled])',
            'product-form input[name="id"]:not([disabled])',
            '[data-product-form] input[name="id"]:not([disabled])',
            'input[name="id"][data-product-variant-id]:not([disabled])',
            'input[name="id"]:not([disabled])'
        ];

        for (let selector of selectors) {
            const input = document.querySelector(selector);
            if (input && input.value) {
                const id = parseInt(input.value, 10);
                if (Number.isInteger(id) && id > 0) {
                    debug(`Found variant ID via selector: ${selector} = ${id}`);
                    return id;
                }
            }
        }

        // window.meta'dan kontrol et
        if (window.meta && window.meta.product && window.meta.product.variants) {
            // Seçili varyantı bulmaya çalış
            const variantInputs = document.querySelectorAll('input[name="Varyant"]:checked');
            if (variantInputs.length > 0) {
                const selectedVariantName = variantInputs[0].value;
                const matchedVariant = window.meta.product.variants.find(v => v.option1 === selectedVariantName);
                if (matchedVariant) {
                    debug(`Found variant ID via window.meta for ${selectedVariantName}: ${matchedVariant.id}`);
                    return matchedVariant.id;
                }
            }

            // Yoksa ilk available varyantı al
            const currentVariant = window.meta.product.variants.find(v => v.available);
            if (currentVariant) {
                debug('Found variant ID via window.meta (first available)');
                return currentVariant.id;
            }
        }

        debug('No variant ID found');
        return null;
    }

    // Seçili A/B varyantını algıla (Shopify variant option'dan)
    function getSelectedVariantCode() {
        try {
            // Yöntem 1: Shopify variant selector'dan (Option1)
            const variantSelect = document.querySelector('select[name="options[Variant]"], select[data-option="Variant"]');
            if (variantSelect && variantSelect.value) {
                debug(`Variant code from select: ${variantSelect.value}`);
                return variantSelect.value;
            }

            // Yöntem 2: Radio button'dan
            const variantRadio = document.querySelector('input[name="options[Variant]"]:checked');
            if (variantRadio && variantRadio.value) {
                debug(`Variant code from radio: ${variantRadio.value}`);
                return variantRadio.value;
            }

            // Yöntem 3: Shopify product JSON'dan (seçili variant)
            if (window.meta && window.meta.product) {
                const variantId = getCurrentVariantId();
                if (variantId && window.meta.product.variants) {
                    const variant = window.meta.product.variants.find(v => v.id === variantId);
                    if (variant && variant.option1) {
                        debug(`Variant code from product JSON: ${variant.option1}`);
                        return variant.option1;
                    }
                }
            }

            // Yöntem 4: DOM'dan variant label'ı bul (fallback)
            const variantLabels = document.querySelectorAll('[data-variant-option], .variant-input__label.active, .variant-option.active');
            for (const label of variantLabels) {
                const code = label.getAttribute('data-value') || label.textContent.trim();
                if (code && (code.startsWith('A-') || code.startsWith('B-'))) {
                    debug(`Variant code from DOM label: ${code}`);
                    return code;
                }
            }

            debug('No variant code found');
            return null;

        } catch (e) {
            debug('Error getting variant code:', e);
            return null;
        }
    }

    // Tüm seçili varyantları al (Renk, Beden, Material, vs.)
    function getAllSelectedVariants() {
        const variants = {};

        try {
            // Yöntem 1: Shopify form input'larından al (select ve radio)
            const variantSelects = document.querySelectorAll('select[name^="options["]');
            variantSelects.forEach(select => {
                if (select.value && select.name) {
                    // "options[Renk]" formatından "Renk" çıkar
                    const optionName = select.name.match(/options\[([^\]]+)\]/);
                    if (optionName && optionName[1]) {
                        // "Fiyat Grubu" olanları atla
                        const name = optionName[1];
                        if (!name.toLowerCase().includes('fiyat grubu') &&
                            !name.toLowerCase().includes('price group')) {
                            variants[name] = select.value;
                        }
                    }
                }
            });

            // Radio button'ları da kontrol et
            const variantRadios = document.querySelectorAll('input[type="radio"][name^="options["]:checked');
            variantRadios.forEach(radio => {
                if (radio.value && radio.name) {
                    const optionName = radio.name.match(/options\[([^\]]+)\]/);
                    if (optionName && optionName[1]) {
                        const name = optionName[1];
                        if (!name.toLowerCase().includes('fiyat grubu') &&
                            !name.toLowerCase().includes('price group')) {
                            variants[name] = radio.value;
                        }
                    }
                }
            });

            // Yöntem 2: Shopify product variant object'inden al
            if (Object.keys(variants).length === 0 && window.meta && window.meta.product) {
                const variantId = getCurrentVariantId();
                if (variantId && window.meta.product.variants) {
                    const variant = window.meta.product.variants.find(v => v.id === variantId);
                    if (variant) {
                        // Option names'i al
                        const product = window.meta.product;
                        if (product.options) {
                            product.options.forEach((option, index) => {
                                const optionKey = `option${index + 1}`;
                                const optionValue = variant[optionKey];

                                if (optionValue && option.name) {
                                    const name = option.name;
                                    if (!name.toLowerCase().includes('fiyat grubu') &&
                                        !name.toLowerCase().includes('price group')) {
                                        variants[name] = optionValue;
                                    }
                                }
                            });
                        }
                    }
                }
            }

            // Yöntem 3: DOM'dan .wt-product__option element'lerinden al
            if (Object.keys(variants).length === 0) {
                const options = document.querySelectorAll('.wt-product__option');
                options.forEach(option => {
                    const titleEl = option.querySelector('.wt-product__option__title .label');

                    // Radio button için
                    let selectedInput = option.querySelector('input[type="radio"]:checked');

                    // Yoksa select için
                    if (!selectedInput) {
                        selectedInput = option.querySelector('select');
                    }

                    if (titleEl && selectedInput) {
                        const name = titleEl.textContent.trim();
                        let value = selectedInput.value;

                        // Eğer select ise, seçili option'ın text'ini al
                        if (selectedInput.tagName === 'SELECT' && !value) {
                            value = selectedInput.options[selectedInput.selectedIndex]?.value;
                        }

                        if (name && value &&
                            !name.toLowerCase().includes('fiyat grubu') &&
                            !name.toLowerCase().includes('price group')) {
                            variants[name] = value;
                        }
                    }
                });
            }

            debug('All selected variants:', variants);
            return variants;

        } catch (e) {
            debug('Error getting all variants:', e);
            return {};
        }
    }

    // Ürün varyantlarının tüm option'larını al (tüm olası değerler)
    function getProductVariantOptions() {
        const variantOptions = {};

        try {
            console.log('[Vienetta] Checking window.meta:', window.meta);
            console.log('[Vienetta] Checking window.meta.product:', window.meta?.product);
            console.log('[Vienetta] Checking window.meta.product.options:', window.meta?.product?.options);

            // Yöntem 1: Shopify product JSON'dan
            if (window.meta && window.meta.product && window.meta.product.options && window.meta.product.options.length > 0) {
                console.log('[Vienetta] Found product.options:', window.meta.product.options);

                window.meta.product.options.forEach((option) => {
                    const name = option.name;
                    const values = option.values || [];

                    console.log(`[Vienetta] Processing option: ${name}, values:`, values);

                    // "Fiyat Grubu" olanları atla
                    if (!name.toLowerCase().includes('fiyat grubu') &&
                        !name.toLowerCase().includes('price group')) {
                        variantOptions[name] = values;
                        console.log(`[Vienetta] Added variant option: ${name}`);
                    } else {
                        console.log(`[Vienetta] Skipped "Fiyat Grubu": ${name}`);
                    }
                });

                debug('Variant options from product JSON:', variantOptions);
                console.log('[Vienetta] Returning variant options from JSON:', variantOptions);
                return variantOptions;
            }

            console.log('[Vienetta] window.meta.product not found, trying DOM method');

            // Yöntem 2: DOM'dan select/radio element'lerini parse et
            const variantSelects = document.querySelectorAll('select[name^="options["]');
            console.log('[Vienetta] Found variant selects in DOM:', variantSelects.length);
            variantSelects.forEach(select => {
                if (select.name) {
                    const optionName = select.name.match(/options\[([^\]]+)\]/);
                    if (optionName && optionName[1]) {
                        const name = optionName[1];

                        if (!name.toLowerCase().includes('fiyat grubu') &&
                            !name.toLowerCase().includes('price group')) {
                            const values = [];
                            Array.from(select.options).forEach(option => {
                                if (option.value && !option.disabled) {
                                    values.push(option.value);
                                }
                            });
                            if (values.length > 0) {
                                variantOptions[name] = values;
                            }
                        }
                    }
                }
            });

            // Radio button'ları da kontrol et
            const radioGroups = {};
            const variantRadios = document.querySelectorAll('input[type="radio"][name^="options["]');
            variantRadios.forEach(radio => {
                if (radio.name && radio.value) {
                    const optionName = radio.name.match(/options\[([^\]]+)\]/);
                    if (optionName && optionName[1]) {
                        const name = optionName[1];

                        if (!name.toLowerCase().includes('fiyat grubu') &&
                            !name.toLowerCase().includes('price group')) {
                            if (!radioGroups[name]) {
                                radioGroups[name] = [];
                            }
                            if (!radioGroups[name].includes(radio.value)) {
                                radioGroups[name].push(radio.value);
                            }
                        }
                    }
                }
            });

            // Radio group'ları ekle
            Object.assign(variantOptions, radioGroups);

            // Yöntem 3: .wt-product__option element'lerinden al (tema özel)
            if (Object.keys(variantOptions).length === 0) {
                console.log('[Vienetta] Trying .wt-product__option method...');
                const wtOptions = document.querySelectorAll('.wt-product__option');
                console.log('[Vienetta] Found .wt-product__option elements:', wtOptions.length);

                wtOptions.forEach(option => {
                    const titleEl = option.querySelector('.wt-product__option__title .label');
                    if (!titleEl) return;

                    const name = titleEl.textContent.trim();
                    console.log('[Vienetta] Processing wt-product__option:', name);

                    // "Fiyat Grubu" olanları atla
                    if (name.toLowerCase().includes('fiyat grubu') ||
                        name.toLowerCase().includes('price group')) {
                        console.log('[Vienetta] Skipped Fiyat Grubu:', name);
                        return;
                    }

                    const values = [];

                    // Radio button'lardan değerleri al
                    const radioInputs = option.querySelectorAll('input[type="radio"]');
                    radioInputs.forEach(radio => {
                        if (radio.value) {
                            values.push(radio.value);
                        }
                    });

                    // Select'ten değerleri al
                    const selectInput = option.querySelector('select');
                    if (selectInput) {
                        Array.from(selectInput.options).forEach(opt => {
                            if (opt.value && !opt.disabled) {
                                values.push(opt.value);
                            }
                        });
                    }

                    if (values.length > 0) {
                        variantOptions[name] = values;
                        console.log(`[Vienetta] Added variant option from wt-product: ${name}`, values);
                    }
                });
            }

            debug('Variant options from DOM:', variantOptions);
            console.log('[Vienetta] Final variant options:', variantOptions);
            return variantOptions;

        } catch (e) {
            debug('Error getting product variant options:', e);
            console.error('[Vienetta] Error getting variant options:', e);
            return {};
        }
    }

    // Popup'ta varyant select'lerini oluştur
    function createVariantSelects() {
        const variantFieldsContainer = document.getElementById('preorder-variant-fields');
        if (!variantFieldsContainer) {
            console.warn('[Vienetta] Variant fields container not found!');
            return;
        }

        // Temizle
        variantFieldsContainer.innerHTML = '';

        const variantOptions = getProductVariantOptions();
        const selectedVariants = getAllSelectedVariants();

        console.log('[Vienetta] Variant options found:', variantOptions);
        console.log('[Vienetta] Currently selected variants:', selectedVariants);

        if (Object.keys(variantOptions).length === 0) {
            console.warn('[Vienetta] No variant options to create selects for');
            debug('No variant options to create selects for');
            return;
        }

        // Her varyant için bir select oluştur
        Object.entries(variantOptions).forEach(([optionName, optionValues], index) => {
            const fieldDiv = document.createElement('div');
            fieldDiv.className = 'preorder-form-field';

            const label = document.createElement('label');
            label.className = 'preorder-form-label';
            label.textContent = translateLabel(optionName); // Display in English
            label.setAttribute('for', `preorder-variant-${index}`);

            const select = document.createElement('select');
            select.id = `preorder-variant-${index}`;
            select.className = 'preorder-form-select notranslate';
            select.name = optionName;
            select.required = true;
            select.dataset.variantOption = optionName;
            select.setAttribute('translate', 'no'); // Weglot/translation tools bypass

            // "Seçiniz..." placeholder option
            const defaultOption = document.createElement('option');
            defaultOption.value = '';
            defaultOption.textContent = 'Seçiniz...';
            defaultOption.disabled = true;
            defaultOption.selected = true;
            select.appendChild(defaultOption);

            // Option'ları ekle
            optionValues.forEach(value => {
                const optionElement = document.createElement('option');
                optionElement.value = value;
                optionElement.dataset.originalText = value;
                optionElement.dataset.translatedText = translateLabel(value);
                optionElement.textContent = translateLabel(value); // Cevir
                optionElement.setAttribute('translate', 'no'); // Prevent external translation tools
                optionElement.className = 'notranslate';

                // Eğer bu değer şu an seçiliyse, seçili yap
                if (selectedVariants[optionName] === value) {
                    optionElement.selected = true;
                    defaultOption.selected = false;
                }

                select.appendChild(optionElement);
            });

            // Wrapper div'i select için oluştur
            const selectWrapper = document.createElement('div');
            selectWrapper.className = 'preorder-select-wrapper';
            selectWrapper.appendChild(select);

            // Değişiklik dinleyicisi ekle (popup'tan product page'e senkronize et)
            select.addEventListener('change', async () => {
                await syncVariantToProductPage(optionName, select.value);

                // Eğer bu Varyant field'ı ise ve mapping varsa, doğrudan ID'yi al
                if (optionName === 'Varyant' || optionName === 'Variant') {
                    if (window.preorderVariantMap && window.preorderVariantMap[select.value]) {
                        const mappedVariantId = window.preorderVariantMap[select.value];
                        debug(`Variant changed - Using mapped ID for ${select.value}: ${mappedVariantId}`);

                        const modal = document.getElementById('preorder-modal');
                        if (modal) {
                            modal.setAttribute('data-current-variant-id', mappedVariantId);
                            debug(`Modal variant ID updated to: ${mappedVariantId}`);
                        }

                        // Also update the input directly
                        const variantIdInput = document.querySelector('input[name="id"]');
                        if (variantIdInput) {
                            variantIdInput.value = mappedVariantId;
                            debug(`Input[name="id"] updated to: ${mappedVariantId}`);
                        }
                    } else {
                        debug(`Warning: No mapping found for variant: ${select.value}`);

                        // Try to find variant in meta.product
                        if (window.meta && window.meta.product && window.meta.product.variants) {
                            const variant = window.meta.product.variants.find(v => v.option1 === select.value);
                            if (variant) {
                                debug(`Found variant in meta.product: ${variant.id}`);
                                const modal = document.getElementById('preorder-modal');
                                if (modal) {
                                    modal.setAttribute('data-current-variant-id', variant.id);
                                }
                            }
                        }
                    }
                } else {
                    // Shopify'nin varyantı güncellemesi için bekle
                    setTimeout(() => {
                        const newVariantId = getCurrentVariantId();
                        debug(`Variant changed - ${optionName}: ${select.value}, New ID: ${newVariantId}`);

                        // Variant ID'yi data attribute olarak sakla
                        const modal = document.getElementById('preorder-modal');
                        if (modal) {
                            modal.setAttribute('data-current-variant-id', newVariantId);
                        }
                    }, 200);
                }
            });

            fieldDiv.appendChild(label);
            fieldDiv.appendChild(selectWrapper);
            variantFieldsContainer.appendChild(fieldDiv);
        });

        console.log(`[Vienetta] Created ${Object.keys(variantOptions).length} variant select fields`);
        console.log('[Vienetta] Variant fields container HTML:', variantFieldsContainer.innerHTML.substring(0, 500));
        debug('Variant selects created in popup');

        // After creating selects, check if a variant is already selected and update modal ID
        const variantSelect = document.querySelector('#preorder-variant-fields select[name="Varyant"], #preorder-variant-fields select[name="Variant"]');
        if (variantSelect && variantSelect.value) {
            const selectedVariant = variantSelect.value;
            if (window.preorderVariantMap && window.preorderVariantMap[selectedVariant]) {
                const variantId = window.preorderVariantMap[selectedVariant];
                const modal = document.getElementById('preorder-modal');
                if (modal) {
                    modal.setAttribute('data-current-variant-id', variantId);
                    debug(`Initial variant selected in popup: ${selectedVariant} -> ID: ${variantId}`);
                }
            }
        }

        // Alt varyantları ekle (sadece popup'ta gösterilecek)
        addAltVariantSelects(variantFieldsContainer, selectedVariants);
    }

    // Alt varyantları popup'ta göster (sadece bilgi amaçlı, ust varyantına bağlı)
    function addAltVariantSelects(container, selectedVariants) {
        try {
            // HTML'den alt varyant verisini oku
            const altVariantsDiv = document.getElementById('alt-variants-data');
            if (!altVariantsDiv) {
                debug('No alt variants data found');
                return;
            }

            const altVariantsJson = altVariantsDiv.getAttribute('data-alt-variants');
            if (!altVariantsJson) {
                debug('Alt variants data is empty');
                return;
            }

            const altVariants = JSON.parse(altVariantsJson);
            console.log('[Vienetta] Alt variants found:', altVariants);

            // Seçili ust varyantı bul (Varyant adlı select'ten)
            const ustVariantSelect = document.querySelector('#preorder-variant-fields select[data-variant-option="Varyant"]');
            if (!ustVariantSelect) {
                debug('No ust variant select found');
                return;
            }

            // Ust varyant değiştiğinde alt varyantı güncelle
            const updateAltVariant = () => {
                const selectedValue = ustVariantSelect.value;
                if (!selectedValue) return;

                // A- veya B- ile başlıyorsa o harfi al
                let letter = null;
                if (selectedValue.startsWith('A-')) {
                    letter = 'A';
                } else if (selectedValue.startsWith('B-')) {
                    letter = 'B';
                }

                // Mevcut alt varyant select'ini kaldır
                const existingAltSelect = document.getElementById('preorder-alt-variant-field');
                if (existingAltSelect) {
                    existingAltSelect.remove();
                }

                // Eğer ilgili alt varyant varsa, ekle
                if (letter && altVariants[letter]) {
                    const fieldDiv = document.createElement('div');
                    fieldDiv.id = 'preorder-alt-variant-field';
                    fieldDiv.className = 'preorder-form-field';

                    const label = document.createElement('label');
                    label.className = 'preorder-form-label';
                    label.textContent = 'Alt Varyant (Bilgi Amaçlı)';

                    const input = document.createElement('input');
                    input.type = 'text';
                    input.className = 'preorder-form-input';
                    input.value = altVariants[letter];
                    input.disabled = true; // Salt okunur
                    input.style.backgroundColor = '#f5f5f5';
                    input.style.cursor = 'not-allowed';

                    const wrapper = document.createElement('div');
                    wrapper.className = 'preorder-select-wrapper';
                    wrapper.appendChild(input);

                    fieldDiv.appendChild(label);
                    fieldDiv.appendChild(wrapper);
                    container.appendChild(fieldDiv);

                    debug(`Alt variant displayed for ${letter}: ${altVariants[letter]}`);
                }
            };

            // İlk yükleme
            if (ustVariantSelect.value) {
                updateAltVariant();
            }

            // Değişiklik dinleyicisi
            ustVariantSelect.addEventListener('change', updateAltVariant);

        } catch (e) {
            debug('Error adding alt variant selects:', e);
            console.error('[Vienetta] Alt variant error:', e);
        }
    }

    // Popup'taki varyant değişikliğini product page'e senkronize et
    async function syncVariantToProductPage(optionName, optionValue) {
        return new Promise((resolve) => {
            try {
                debug(`Syncing variant to product page: ${optionName} = ${optionValue}`);

                // Yöntem 1: Select element'ini bul ve değiştir
                const selectElement = document.querySelector(`select[name="options[${optionName}]"]`);
                if (selectElement) {
                    selectElement.value = optionValue;
                    selectElement.dispatchEvent(new Event('change', { bubbles: true }));
                    debug(`Updated select: ${optionName}`);
                    setTimeout(resolve, 100); // Shopify'nin güncelleme yapması için bekle
                    return;
                }

                // Yöntem 2: Radio button'ı bul ve seç
                const radioElement = document.querySelector(`input[type="radio"][name="options[${optionName}]"][value="${optionValue}"]`);
                if (radioElement) {
                    radioElement.checked = true;
                    radioElement.dispatchEvent(new Event('change', { bubbles: true }));
                    debug(`Updated radio: ${optionName}`);
                    setTimeout(resolve, 100); // Shopify'nin güncelleme yapması için bekle
                    return;
            }

            // Yöntem 3: Shopify variant API'si varsa kullan
            if (window.meta && window.meta.product && window.meta.product.variants) {
                // Tüm popup'taki seçili varyantları al
                const popupVariants = {};
                const variantSelects = document.querySelectorAll('#preorder-variant-fields select');
                variantSelects.forEach(select => {
                    if (select.value) {
                        popupVariants[select.name] = select.value;
                    }
                });

                // Debug: Log popup variants
                debug(`Popup variants selected: ${JSON.stringify(popupVariants)}`);
                debug(`Available product variants: ${window.meta.product.variants.map(v => `${v.id}: ${v.option1}`).join(', ')}`);

                // Eşleşen variant'ı bul
                const matchingVariant = window.meta.product.variants.find(variant => {
                    const matches = Object.entries(popupVariants).every(([name, value]) => {
                        const product = window.meta.product;
                        const optionIndex = product.options.findIndex(opt => opt.name === name);
                        if (optionIndex === -1) return true;
                        const optionKey = `option${optionIndex + 1}`;
                        const variantValue = variant[optionKey];
                        debug(`  Checking ${name}: variant has '${variantValue}', looking for '${value}' - Match: ${variantValue === value}`);
                        return variantValue === value;
                    });
                    if (matches) {
                        debug(`Found matching variant: ${variant.id} - ${variant.option1}`);
                    }
                    return matches;
                });

                if (matchingVariant) {
                    // Variant ID input'unu güncelle
                    const variantIdInput = document.querySelector('input[name="id"]');
                    if (variantIdInput) {
                        variantIdInput.value = matchingVariant.id;
                        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
                        debug(`Updated variant ID to: ${matchingVariant.id}`);

                        // variant-options elementinin data-variant-id'sini de güncelle
                        const variantOptionsEl = document.querySelector('variant-options');
                        if (variantOptionsEl) {
                            variantOptionsEl.setAttribute('data-variant-id', matchingVariant.id);
                            debug(`Updated variant-options data-variant-id to: ${matchingVariant.id}`);
                        }
                    }
                } else {
                    debug('Warning: No matching variant found in window.meta.product.variants');

                    // Fallback: Try to find variant by name directly if only "Varyant" option is selected
                    if (popupVariants['Varyant'] && window.meta.product.variants) {
                        const variantByName = window.meta.product.variants.find(v => v.option1 === popupVariants['Varyant']);
                        if (variantByName) {
                            debug(`Fallback: Found variant by name match: ${variantByName.id} - ${variantByName.option1}`);

                            const variantIdInput = document.querySelector('input[name="id"]');
                            if (variantIdInput) {
                                variantIdInput.value = variantByName.id;
                                variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
                            }

                            const variantOptionsEl = document.querySelector('variant-options');
                            if (variantOptionsEl) {
                                variantOptionsEl.setAttribute('data-variant-id', variantByName.id);
                            }
                        }
                    }
                }
            }

            debug('Variant synced to product page');
            setTimeout(resolve, 100); // Tüm güncellemelerin tamamlanması için bekle

        } catch (e) {
            debug('Error syncing variant to product page:', e);
            resolve(); // Hata durumunda da resolve et
        }
        });
    }

    // Product page'deki varyant değişikliğini popup'a senkronize et
    function syncVariantToPopup() {
        const variantFieldsContainer = document.getElementById('preorder-variant-fields');
        if (!variantFieldsContainer) {
            return;
        }

        const selectedVariants = getAllSelectedVariants();

        // Popup'taki select'leri güncelle
        const variantSelects = variantFieldsContainer.querySelectorAll('select[data-variant-option]');
        variantSelects.forEach(select => {
            const optionName = select.dataset.variantOption;
            if (selectedVariants[optionName]) {
                select.value = selectedVariants[optionName];
            }
        });

        debug('Variant synced to popup from product page');
    }

    // Shopify varyant değişikliklerini dinle (product page -> popup senkronizasyonu)
    function observeVariantChanges() {
        // Yöntem 1: Form input değişikliklerini dinle
        const variantInputs = document.querySelectorAll('select[name^="options["], input[type="radio"][name^="options["]');
        variantInputs.forEach(input => {
            input.addEventListener('change', () => {
                debug('Variant changed via input on product page');
                syncVariantToPopup();
            });
        });

        // Yöntem 2: Shopify'ın variant:change event'ini dinle (eğer varsa)
        document.addEventListener('variant:change', () => {
            debug('Variant changed via Shopify event');
            syncVariantToPopup();
        });

        // Yöntem 3: MutationObserver ile hidden input[name="id"] değişikliklerini izle
        const variantIdInput = document.querySelector('input[name="id"]');
        if (variantIdInput) {
            const observer = new MutationObserver(() => {
                debug('Variant ID changed via mutation');
                syncVariantToPopup();
            });
            observer.observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });
        }

        // Yöntem 4: Global mutation observer ile tüm form değişikliklerini izle
        const productForm = document.querySelector('form[action*="/cart/add"], product-form');
        if (productForm) {
            const formObserver = new MutationObserver(() => {
                syncVariantToPopup();
            });
            formObserver.observe(productForm, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['value', 'checked', 'selected']
            });
        }

        debug('Variant change observers initialized (product page -> popup sync)');
    }

    function showError(message) {
        const errorDiv = document.getElementById('preorder-error');
        errorDiv.textContent = message;
        errorDiv.style.display = 'block';
        errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
        debug(`Error shown: ${message}`);
    }

    function clearError() {
        const errorDiv = document.getElementById('preorder-error');
        errorDiv.style.display = 'none';
        errorDiv.textContent = '';
    }

    function showSuccessNotification(message) {
        const toast = document.createElement('div');
        toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #4caf50;
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      font-weight: 500;
      z-index: 10001;
      opacity: 0;
      transition: opacity 0.3s ease;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      max-width: 300px;
      word-wrap: break-word;
      white-space: pre-line;
    `;
        toast.textContent = message;

        document.body.appendChild(toast);

        setTimeout(() => toast.style.opacity = '1', 100);

        setTimeout(() => {
            toast.style.opacity = '0';
            setTimeout(() => {
                if (document.body.contains(toast)) {
                    document.body.removeChild(toast);
                }
            }, 300);
        }, 4000);

        debug(`Success notification: ${message}`);
    }

    function observeForPreorderElement() {
        if (isInitialized) return;

        const observer = new MutationObserver((mutations) => {
            for (let mutation of mutations) {
                if (mutation.type === 'childList') {
                    const selector = PREORDER_CONFIG.sourceSelector || '#preorders';
                    if (document.querySelector(selector)) {
                        debug('Preorder element detected via observer');
                        init();
                        observer.disconnect();
                        break;
                    }
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        setTimeout(() => {
            observer.disconnect();
            debug('Observer disconnected after timeout');
        }, 10000);
    }

    function observeForAddToCartButton() {
        if (!PREORDER_CONFIG.replaceAddToCartButton || isInitialized) return;

        const observer = new MutationObserver((mutations) => {
            for (let mutation of mutations) {
                if (mutation.type === 'childList') {
                    const addToCartSelectors = [
                        'button[name="add"]',
                        '.js-add-to-cart',
                        'input[name="add"][type="submit"]',
                        'button[type="submit"][aria-label*="Add to cart"]'
                    ];

                    for (let selector of addToCartSelectors) {
                        if (document.querySelector(selector)) {
                            debug('Add to cart button detected via observer');
                            init();
                            observer.disconnect();
                            return;
                        }
                    }
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        setTimeout(() => {
            observer.disconnect();
            debug('Add to cart observer disconnected after timeout');
        }, 10000);
    }

    // Ürün kodlarını parse et (HTML'den)
    function parseProductCodes() {
        try {
            // product-code-info div'ini bul
            const codeDiv = document.querySelector('.product-code-info');
            if (!codeDiv) {
                debug('Product code div not found');
                return null;
            }

            // "Ürün Kodu: PNY-9667 BAZ-3 6518" formatındaki metni bul
            const codeText = codeDiv.textContent || '';
            const match = codeText.match(/Ürün\s*Kodu:\s*([^\s]+)(?:\s+([^\s]+))?(?:\s+([^\s]+))?/i);

            if (!match) {
                debug('Product code pattern not matched');
                return null;
            }

            const codes = {
                barcode: match[1] || null,
                baz: match[2] || null,
                moldNumber: match[3] || null
            };

            debug('Parsed product codes:', codes);
            return codes;
        } catch (e) {
            debug('Error parsing product codes:', e);
            return null;
        }
    }

    // Ürün kodlarını başlık altında göster
    function displayProductCodes() {
        const codes = parseProductCodes();
        if (!codes || !codes.barcode) {
            debug('No product codes to display');
            return;
        }

        // Ürün başlığını bul
        const titleSelectors = [
            'h1.product__title',
            'h1.product-title',
            '.product-single__title',
            '.product__title',
            'h1[itemprop="name"]',
            'h1'
        ];

        let titleElement = null;
        for (const selector of titleSelectors) {
            titleElement = document.querySelector(selector);
            if (titleElement && titleElement.offsetParent !== null) {
                debug(`Found title element with selector: ${selector}`);
                break;
            }
        }

        if (!titleElement) {
            debug('Product title element not found');
            return;
        }

        // Eğer zaten varsa, tekrar ekleme
        if (document.getElementById('preorder-product-codes')) {
            debug('Product codes already displayed');
            return;
        }

        // Ürün kodu display elementi oluştur
        const codesContainer = document.createElement('div');
        codesContainer.id = 'preorder-product-codes';
        codesContainer.className = 'preorder-product-codes';

        let html = '';

        if (codes.barcode) {
            html += `<div class="product-code-item"><span class="code-label">Barcode:</span> <span class="code-value">${codes.barcode}</span></div>`;
        }

        if (codes.baz) {
            html += `<div class="product-code-item"><span class="code-label">Baz:</span> <span class="code-value">${codes.baz}</span></div>`;
        }

        if (codes.moldNumber) {
            html += `<div class="product-code-item"><span class="code-label">Mold Number:</span> <span class="code-value">${codes.moldNumber}</span></div>`;
        }

        codesContainer.innerHTML = html;

        // ZORLA TEK SATIRDA GÖSTER - Inline styles ile CSS override
        codesContainer.style.cssText = `
            display: flex !important;
            flex-direction: row !important;
            flex-wrap: nowrap !important;
            gap: 16px !important;
            margin: 12px 0 20px 0 !important;
            padding: 14px 18px !important;
            background: #f9fafb !important;
            border: 1px solid #e5e7eb !important;
            border-radius: 4px !important;
            font-size: 14px !important;
            line-height: 1.6 !important;
            overflow: visible !important;
            width: fit-content !important;
            max-width: 100% !important;
        `;

        // Başlığın hemen sonrasına ekle
        if (titleElement.nextSibling) {
            titleElement.parentNode.insertBefore(codesContainer, titleElement.nextSibling);
        } else {
            titleElement.parentNode.appendChild(codesContainer);
        }

        // Her bir product-code-item'a da inline style ekle
        const codeItems = codesContainer.querySelectorAll('.product-code-item');
        codeItems.forEach(item => {
            item.style.cssText = `
                display: inline-flex !important;
                align-items: baseline !important;
                gap: 6px !important;
                white-space: nowrap !important;
                flex-shrink: 0 !important;
            `;
        });

        debug('Product codes displayed successfully');
    }

    // ========================================
    // DEADLINE COUNTDOWN TIMER
    // ========================================

    let deadlineInfo = null;
    let countdownInterval = null;

    // Parse preorder info from product tags (faster than API)
    function getPreorderInfoFromTags() {
        const tags = PREORDER_CONFIG.productTags || [];
        if (!tags || tags.length === 0) {
            debug('[Tags] No product tags available');
            return null;
        }

        debug('[Tags] Checking product tags:', tags);

        let deadline = null;
        let production_days = 30; // default

        for (const tag of tags) {
            if (tag.startsWith('preorder_deadline:')) {
                deadline = tag.replace('preorder_deadline:', '');
                debug(`[Tags] Found deadline: ${deadline}`);
            }
            if (tag.startsWith('preorder_production:')) {
                production_days = parseInt(tag.replace('preorder_production:', '')) || 30;
                debug(`[Tags] Found production days: ${production_days}`);
            }
        }

        if (deadline || production_days !== 30) {
            return {
                deadline: deadline,
                production_days: production_days,
                fromTags: true
            };
        }

        return null;
    }

    // Deadline bilgisini tag'lerden veya API'den çek
    async function fetchDeadlineInfo() {
        try {
            // First try to get from tags (instant, no API call)
            const tagInfo = getPreorderInfoFromTags();
            if (tagInfo) {
                debug('[Deadline Fetch] Got info from tags (fast path)');
                return tagInfo;
            }

            debug('[Deadline Fetch] No tag info, falling back to API...');

            const productInfo = getProductInfo();
            const productHandle = productInfo.handle;
            const productTitle = productInfo.title;

            debug(`[Deadline Fetch] Product handle: ${productHandle}`);
            debug(`[Deadline Fetch] Product title: ${productTitle}`);

            // API'den deadline bilgisini çek
            // KZK backend base URL'i PREORDER_CONFIG.apiUrl'dan al
            const apiUrl = (PREORDER_CONFIG.apiUrl || 'https://patronundan.com/preorders') + '/products';

            debug(`[Deadline Fetch] Fetching from: ${apiUrl}`);
            const response = await fetch(apiUrl);

            if (!response.ok) {
                debug(`[Deadline Fetch] API error: ${response.status} ${response.statusText}`);
                return null;
            }

            const result = await response.json();

            // API response farklı formatlarda gelebilir, her ikisini de destekle
            const products = result.products || result || [];

            if (!Array.isArray(products) || products.length === 0) {
                debug('[Deadline Fetch] No product data from API');
                return null;
            }

            debug(`[Deadline Fetch] Received ${products.length} products from API`);

            // Metafield'dan stokkodu kontrolü (eğer varsa)
            let stokkoduFromMeta = null;
            if (window.meta && window.meta.product && window.meta.product.metafields) {
                stokkoduFromMeta = window.meta.product.metafields.stokkodu ||
                                   window.meta.product.metafields.stock_code ||
                                   window.meta.product.metafields.sku;
                if (stokkoduFromMeta) {
                    debug(`[Deadline Fetch] Found stokkodu in metafields: ${stokkoduFromMeta}`);
                }
            }

            // Ürünü bul - birden fazla strateji dene
            let product = null;

            // Strateji 1: Metafield'dan stokkodu ile eşleştir
            if (stokkoduFromMeta) {
                product = products.find(p => p.stokkodu === stokkoduFromMeta);
                if (product) {
                    debug(`[Deadline Fetch] ✓ Match found via metafield stokkodu: ${stokkoduFromMeta}`);
                }
            }

            // Strateji 2: Handle ile direkt eşleştir (stokkodu handle olarak kullanılmışsa)
            if (!product && productHandle) {
                product = products.find(p => p.stokkodu === productHandle.toUpperCase());
                if (product) {
                    debug(`[Deadline Fetch] ✓ Match found via handle as stokkodu: ${productHandle}`);
                }
            }

            // Strateji 3: Normalize edilmiş title ile eşleştir
            if (!product && productHandle) {
                product = products.find(p => {
                    const apiTitleNormalized = (p.title || p.stokadi || '')
                        .toLowerCase()
                        .replace(/\s+/g, '-')
                        .replace(/[^a-z0-9-]/g, '');
                    return apiTitleNormalized === productHandle;
                });
                if (product) {
                    debug(`[Deadline Fetch] ✓ Match found via normalized title`);
                }
            }

            // Strateji 4: Fuzzy match - title içinde kelime eşleşmesi
            if (!product && productTitle) {
                const titleWords = productTitle.toLowerCase().split(/\s+/).filter(w => w.length > 3);
                product = products.find(p => {
                    const apiTitle = (p.title || p.stokadi || '').toLowerCase();
                    const matchCount = titleWords.filter(word => apiTitle.includes(word)).length;
                    return matchCount >= Math.min(3, titleWords.length - 1); // En az 3 kelime veya toplam-1 kelime eşleşmeli
                });
                if (product) {
                    debug(`[Deadline Fetch] ✓ Match found via fuzzy title matching: ${product.stokkodu}`);
                }
            }

            if (!product) {
                debug('[Deadline Fetch] No matching product found in API');
                debug(`[Deadline Fetch] Tried: handle="${productHandle}", title="${productTitle}"`);
                // İlk 3 ürünü göster debug için
                const sampleProducts = products.slice(0, 3).map(p => ({
                    stokkodu: p.stokkodu,
                    title: p.title,
                    stokadi: p.stokadi
                }));
                debug('[Deadline Fetch] Sample API products:', JSON.stringify(sampleProducts, null, 2));
                return null;
            }

            if (product.deadline) {
                debug(`[Deadline Fetch] ✓ Deadline found for ${product.stokkodu}: ${product.deadline}`);
                return {
                    deadline: product.deadline,
                    stokkodu: product.stokkodu,
                    minSiparisAdedi: product.minSiparisAdedi || 0,
                    stats: product.stats || { total_quantity: 0, total_customers: 0, total_amount: 0 }
                };
            } else {
                debug(`[Deadline Fetch] Product found (${product.stokkodu}) but no deadline set`);
                // Still return stats even if no deadline
                return {
                    deadline: null,
                    stokkodu: product.stokkodu,
                    minSiparisAdedi: product.minSiparisAdedi || 0,
                    stats: product.stats || { total_quantity: 0, total_customers: 0, total_amount: 0 }
                };
            }

        } catch (error) {
            console.error('[Deadline Fetch] Error:', error);
            debug(`[Deadline Fetch] Error: ${error.message}`);
            return null;
        }
    }

    // Countdown timer hesapla
    function calculateTimeRemaining(deadline) {
        const now = new Date();
        const deadlineDate = new Date(deadline);
        const diff = deadlineDate - now;

        if (diff < 0) {
            return { expired: true, text: 'Deadline has passed', urgent: false };
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        let text = '';
        let urgent = false;

        if (days > 0) {
            text = `${days} day${days > 1 ? 's' : ''} ${hours} hour${hours !== 1 ? 's' : ''}`;
        } else if (hours > 0) {
            text = `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} min`;
            urgent = hours < 6; // Last 6 hours is urgent
        } else {
            text = `${minutes} min ${seconds} sec`;
            urgent = true;
        }

        return { expired: false, text, urgent, days, hours, minutes, seconds };
    }

    // Deadline countdown display
    async function displayDeadlineCountdown() {
        try {
            deadlineInfo = await fetchDeadlineInfo();

            if (!deadlineInfo) {
                debug('No deadline info to display');
                return;
            }

            // If no deadline but we have product info, still show production days and progress bar
            if (!deadlineInfo.deadline) {
                debug('No deadline to display, but showing production days and progress bar');
                displayProductionDaysStandalone(deadlineInfo);
                displayProgressBar();
                return;
            }

            // Ürün başlığını bul
            const titleSelectors = [
                'h1.product__title',
                'h1.product-title',
                '.product-single__title',
                '.product__title',
                'h1[itemprop="name"]',
                'h1'
            ];

            let titleElement = null;
            for (const selector of titleSelectors) {
                titleElement = document.querySelector(selector);
                if (titleElement && titleElement.offsetParent !== null) {
                    debug(`Found title element with selector: ${selector}`);
                    break;
                }
            }

            if (!titleElement) {
                debug('Product title element not found for deadline display');
                return;
            }

            // Eğer zaten varsa, kaldır
            const existingCountdown = document.getElementById('preorder-deadline-countdown');
            if (existingCountdown) {
                existingCountdown.remove();
            }

            // Countdown container oluştur
            const countdownContainer = document.createElement('div');
            countdownContainer.id = 'preorder-deadline-countdown';
            countdownContainer.className = 'preorder-deadline-countdown';

            // İlk hesaplama
            const remaining = calculateTimeRemaining(deadlineInfo.deadline);

            if (remaining.expired) {
                // Deadline expired
                countdownContainer.innerHTML = `
                    <div class="deadline-expired">
                        <svg class="deadline-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <circle cx="12" cy="12" r="10" stroke-width="2"/>
                            <polyline points="12 6 12 12 16 14" stroke-width="2"/>
                        </svg>
                        <span class="deadline-text">Pre-order period has ended</span>
                    </div>
                `;

                // Disable buttons
                disablePreorderButtons();

            } else {
                // Show countdown
                countdownContainer.innerHTML = `
                    <div class="deadline-active ${remaining.urgent ? 'deadline-urgent' : ''}">
                        <svg class="deadline-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <circle cx="12" cy="12" r="10" stroke-width="2"/>
                            <polyline points="12 6 12 12 16 14" stroke-width="2"/>
                        </svg>
                        <span class="deadline-label">Pre-order deadline:</span>
                        <span class="deadline-timer" id="deadline-timer-text">${remaining.text}</span>
                        <span class="deadline-remaining">remaining</span>
                    </div>
                `;

                // Start real-time countdown
                startCountdownTimer();
            }

            // Başlığın hemen sonrasına ekle
            if (titleElement.nextSibling) {
                titleElement.parentNode.insertBefore(countdownContainer, titleElement.nextSibling);
            } else {
                titleElement.parentNode.appendChild(countdownContainer);
            }

            // CSS - Minimal Wonder theme style (matching product codes box)
            if (!document.getElementById('preorder-deadline-styles')) {
                const style = document.createElement('style');
                style.id = 'preorder-deadline-styles';
                style.textContent = `
                    .preorder-deadline-countdown {
                        margin: 16px 0;
                        padding: 14px 16px;
                        background: #ffffff;
                        border: 1px solid #e5e5e5;
                        border-radius: 4px;
                    }
                    .deadline-active, .deadline-expired {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        color: #121212;
                        font-size: 13px;
                        font-weight: 400;
                        line-height: 1.6;
                        letter-spacing: 0.02em;
                    }
                    .deadline-icon {
                        flex-shrink: 0;
                        opacity: 0.7;
                        stroke: currentColor;
                    }
                    .deadline-label {
                        color: #6b6b6b;
                    }
                    .deadline-timer {
                        font-weight: 600;
                        color: #121212;
                        white-space: nowrap;
                    }
                    .deadline-remaining {
                        color: #6b6b6b;
                    }

                    /* Urgent state (< 24h) */
                    .deadline-urgent {
                        background: #fff5f5;
                        border-color: #fed7d7;
                    }
                    .deadline-urgent .deadline-timer {
                        color: #c53030;
                    }
                    .deadline-urgent .deadline-icon {
                        stroke: #c53030;
                    }

                    /* Expired state */
                    .deadline-expired .deadline-text {
                        color: #6b6b6b;
                        font-style: italic;
                    }

                    /* Mobile */
                    @media (max-width: 749px) {
                        .preorder-deadline-countdown {
                            padding: 12px 14px;
                        }
                        .deadline-active, .deadline-expired {
                            font-size: 12px;
                        }
                    }
                `;
                document.head.appendChild(style);
            }

            debug('Deadline countdown displayed successfully');

            // Display production days info after deadline countdown
            displayProductionDays(deadlineInfo);

            // Also display progress bar after deadline countdown
            displayProgressBar();

        } catch (error) {
            console.error('Error displaying deadline countdown:', error);
            debug(`Deadline display error: ${error.message}`);
        }
    }

    // Production days display (standalone - when no deadline)
    function displayProductionDaysStandalone(productInfo) {
        try {
            if (!productInfo) return;

            const productionDays = productInfo.production_days || 30;

            // Find title element
            const titleSelectors = [
                'h1.product__title', 'h1.product-title', '.product-single__title',
                '.product__title', 'h1[itemprop="name"]', 'h1'
            ];
            let titleElement = null;
            for (const selector of titleSelectors) {
                titleElement = document.querySelector(selector);
                if (titleElement && titleElement.offsetParent !== null) break;
            }
            if (!titleElement) return;

            // Remove existing
            const existing = document.getElementById('preorder-production-days');
            if (existing) existing.remove();

            // Create container
            const container = document.createElement('div');
            container.id = 'preorder-production-days';
            container.className = 'preorder-production-days';
            container.innerHTML = `
                <div class="production-days-content">
                    <svg class="production-days-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke-width="2"/>
                        <line x1="16" y1="2" x2="16" y2="6" stroke-width="2"/>
                        <line x1="8" y1="2" x2="8" y2="6" stroke-width="2"/>
                        <line x1="3" y1="10" x2="21" y2="10" stroke-width="2"/>
                    </svg>
                    <span class="production-days-text">
                        This product's production and packaging time is <strong>${productionDays} business days</strong>.
                        <span class="production-days-note">(This time period starts after the product enters the production phase)</span>
                    </span>
                </div>
            `;

            // Insert after title
            if (titleElement.nextSibling) {
                titleElement.parentNode.insertBefore(container, titleElement.nextSibling);
            } else {
                titleElement.parentNode.appendChild(container);
            }

            // Add styles (reuse same styles)
            addProductionDaysStyles();
            debug('[Production Days Standalone] Display successful');
        } catch (error) {
            debug(`[Production Days Standalone] Error: ${error.message}`);
        }
    }

    // Add production days CSS styles
    function addProductionDaysStyles() {
        if (document.getElementById('preorder-production-days-styles')) return;

        const style = document.createElement('style');
        style.id = 'preorder-production-days-styles';
        style.textContent = `
            .preorder-production-days {
                margin: 12px 0;
                padding: 14px 16px;
                background: #f8f9fa;
                border: 1px solid #e5e5e5;
                border-radius: 4px;
            }
            .production-days-content {
                display: flex;
                align-items: flex-start;
                gap: 10px;
                color: #121212;
                font-size: 13px;
                font-weight: 400;
                line-height: 1.6;
                letter-spacing: 0.02em;
            }
            .production-days-icon {
                flex-shrink: 0;
                margin-top: 2px;
                opacity: 0.6;
                stroke: #6b6b6b;
            }
            .production-days-text {
                color: #444;
            }
            .production-days-text strong {
                color: #121212;
                font-weight: 600;
            }
            .production-days-note {
                display: block;
                margin-top: 4px;
                font-size: 11px;
                color: #6b6b6b;
                font-style: italic;
            }
            @media (max-width: 749px) {
                .preorder-production-days {
                    padding: 12px 14px;
                }
                .production-days-content {
                    font-size: 12px;
                }
                .production-days-note {
                    font-size: 10px;
                }
            }
        `;
        document.head.appendChild(style);
    }

    // Production days display (after deadline container)
    function displayProductionDays(productInfo) {
        try {
            if (!productInfo) {
                debug('[Production Days] No product info available');
                return;
            }

            const productionDays = productInfo.production_days || 30;
            debug(`[Production Days] Displaying: ${productionDays} business days`);

            // Find deadline container to insert after
            const deadlineContainer = document.getElementById('preorder-deadline-countdown');
            if (!deadlineContainer) {
                debug('[Production Days] Deadline container not found, using standalone');
                displayProductionDaysStandalone(productInfo);
                return;
            }

            // Remove existing production days if present
            const existing = document.getElementById('preorder-production-days');
            if (existing) existing.remove();

            // Create production days container
            const container = document.createElement('div');
            container.id = 'preorder-production-days';
            container.className = 'preorder-production-days';
            container.innerHTML = `
                <div class="production-days-content">
                    <svg class="production-days-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke-width="2"/>
                        <line x1="16" y1="2" x2="16" y2="6" stroke-width="2"/>
                        <line x1="8" y1="2" x2="8" y2="6" stroke-width="2"/>
                        <line x1="3" y1="10" x2="21" y2="10" stroke-width="2"/>
                    </svg>
                    <span class="production-days-text">
                        This product's production and packaging time is <strong>${productionDays} business days</strong>.
                        <span class="production-days-note">(This time period starts after the product enters the production phase)</span>
                    </span>
                </div>
            `;

            // Insert after deadline container
            deadlineContainer.parentNode.insertBefore(container, deadlineContainer.nextSibling);

            // Add styles
            addProductionDaysStyles();
            debug('[Production Days] Display successful');

        } catch (error) {
            console.error('Error displaying production days:', error);
            debug(`[Production Days] Error: ${error.message}`);
        }
    }

    // Varyant bazlı progress bar gösterimi
    // DISABLED: Artık option-based progress bar kullanılıyor (popup içinde)
    async function displayVariantProgressBars() {
        // Variant-based progress bar devre dışı - option-based progress bar popup içinde gösteriliyor
        return false;

        try {
            // Önce ürün bilgisini al
            const productInfo = getProductInfo();
            const productHandle = productInfo.handle;
            const productTitle = productInfo.title;

            // Stokkodu'yu handle'dan çıkar (genelde PNY-XXXX formatında)
            let stokkodu = productHandle.toUpperCase();

            // Alternatif: ürün kodunu sayfadan bulmaya çalış
            const codeElement = document.querySelector('#preorder-product-codes .code-value');
            if (codeElement) {
                const potentialCode = codeElement.textContent.trim();
                if (potentialCode.startsWith('PNY-')) {
                    stokkodu = potentialCode;
                }
            }

            debug(`[Variant Progress] Fetching data for single product: ${stokkodu}`);

            // TEK ÜRÜN için optimize edilmiş endpoint kullan (HIZLI) - KZK backend
            const apiUrl = (PREORDER_CONFIG.apiUrl || 'https://patronundan.com/preorders') + `/products/${stokkodu}`;

            const response = await fetch(apiUrl);

            if (!response.ok) {
                debug('[Variant Progress] API error: ' + response.status);
                return false;
            }

            const result = await response.json();
            const product = result.product;

            if (!product || !product.variant_stats || product.variant_stats.length === 0) {
                debug('[Variant Progress] No variant stats found');
                return false;
            }

            debug(`[Variant Progress] Found product with ${product.variant_stats.length} variants`);

            // Progress bar'ları eklenecek yeri bul
            const titleSelectors = [
                'h1.product__title',
                'h1.product-title',
                '.product-single__title',
                '.product__title',
                'h1[itemprop="name"]',
                'h1'
            ];

            let insertAfterElement = null;
            for (const selector of titleSelectors) {
                insertAfterElement = document.querySelector(selector);
                if (insertAfterElement && insertAfterElement.offsetParent !== null) {
                    break;
                }
            }

            if (!insertAfterElement) {
                debug('[Variant Progress] Could not find element to insert bars after');
                return false;
            }

            // Mevcut progress bar'ları temizle
            const existingBars = document.querySelectorAll('.variant-progress-container, .variant-progress-main-container');
            existingBars.forEach(bar => bar.remove());

            // Ana container oluştur
            const mainContainer = document.createElement('div');
            mainContainer.className = 'variant-progress-main-container';
            mainContainer.innerHTML = '<h4 style="margin-bottom: 12px; font-size: 14px; font-weight: 600;">Variant-Based Preorder Status:</h4>';

            // Minimum sipariş adedini ürün datadan al
            const minQuantity = parseInt(product.minSiparisAdedi) || 1000; // Default 1000

            // Sayfadaki varyant seçeneklerini kontrol et
            const variantOptions = document.querySelectorAll('input[name="Varyant"]');
            const pageVariants = [];
            variantOptions.forEach(opt => {
                const value = opt.value;
                if (value) {
                    pageVariants.push(value);
                }
            });

            debug(`[Variant Progress] Page has ${pageVariants.length} variant options`);

            // Eğer varyant verisi yoksa veya eksikse, sayfadaki varyantları kullan
            if (pageVariants.length > product.variant_stats.length) {
                debug('[Variant Progress] Adding missing variants from page');

                pageVariants.forEach(pageVariant => {
                    const exists = product.variant_stats.find(v =>
                        v.variant_name === pageVariant ||
                        v.variant_id === pageVariant
                    );

                    if (!exists) {
                        product.variant_stats.push({
                            variant_id: pageVariant,
                            variant_name: pageVariant,
                            variant_type: '',
                            total_quantity: 0,
                            total_customers: 0,
                            total_amount: 0
                        });
                    }
                });
            }

            // Eğer hala varyant yoksa, genel stats'ı göster
            if (product.variant_stats.length === 0 && product.stats) {
                debug('[Variant Progress] No variant stats, showing product total');

                // Tek bir bar göster (toplam)
                const totalQuantity = product.stats.total_quantity || 0;
                const percentage = Math.min(100, Math.round((totalQuantity / minQuantity) * 100));
                const remaining = Math.max(0, minQuantity - totalQuantity);

                mainContainer.innerHTML += `
                    <div class="variant-progress-container" style="margin-bottom: 16px; padding: 12px; background: #f7fafc; border: 1px solid #e2e8f0; border-radius: 6px;">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                            <span style="font-weight: 600; font-size: 13px;">📦 Total Progress</span>
                            <span style="font-weight: 600; color: #4a5568; font-size: 13px;">${totalQuantity} / ${minQuantity} units</span>
                        </div>
                        <div style="width: 100%; height: 10px; background: #e2e8f0; border-radius: 5px; overflow: hidden; margin-bottom: 6px;">
                            <div style="height: 100%; background: #3182ce; width: ${percentage}%; transition: width 0.5s ease;"></div>
                        </div>
                        <div style="text-align: center; font-size: 11px; color: #718096;">%${percentage} tamamlandı</div>
                    </div>
                `;
            } else {
                // Her varyant için ayrı progress bar oluştur
                product.variant_stats.forEach((variant, index) => {
                const currentQuantity = variant.total_quantity || 0;
                const percentage = Math.min(100, Math.round((currentQuantity / minQuantity) * 100));
                const remaining = Math.max(0, minQuantity - currentQuantity);
                const customerCount = variant.total_customers || 0;

                // Varyant ID ve ismini göster
                const variantId = variant.variant_id;
                const variantName = variant.variant_name || variantId;
                const variantType = variant.variant_type || ''; // UST veya ALT

                // Renk belirleme
                let barColor = '#3182ce'; // Default mavi
                let statusIcon = '📦';
                let statusText = 'Collecting Orders';

                if (percentage >= 100) {
                    barColor = '#38a169'; // Yeşil
                    statusIcon = '✅';
                    statusText = 'Goal Completed!';
                } else if (percentage >= 75) {
                    barColor = '#d69e2e'; // Sarı/turuncu
                    statusIcon = '🔥';
                    statusText = 'Almost Complete';
                } else if (percentage >= 50) {
                    barColor = '#3182ce'; // Mavi
                    statusIcon = '📈';
                    statusText = 'Progress Continuing';
                }

                // Varyant progress container
                const variantContainer = document.createElement('div');
                variantContainer.className = 'variant-progress-container';
                variantContainer.style.cssText = `
                    margin-bottom: 16px;
                    padding: 12px;
                    background: #f7fafc;
                    border: 1px solid #e2e8f0;
                    border-radius: 6px;
                `;

                variantContainer.innerHTML = `
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                        <div>
                            <span style="font-weight: 700; font-size: 14px; color: #2d3748;">
                                Variant: ${variantName}
                                ${variantType ? ` (${variantType})` : ''}
                            </span>
                            <span style="display: block; color: #718096; font-size: 11px; margin-top: 2px;">
                                ${statusIcon} ${statusText}
                            </span>
                        </div>
                        <span style="font-weight: 600; color: #4a5568; font-size: 13px;">
                            ${currentQuantity} / ${minQuantity} units
                        </span>
                    </div>

                    <div style="width: 100%; height: 10px; background: #e2e8f0; border-radius: 5px; overflow: hidden; margin-bottom: 6px;">
                        <div style="height: 100%; background: ${barColor}; width: ${percentage}%; transition: width 0.5s ease;"></div>
                    </div>

                    <div style="display: flex; justify-content: space-between; font-size: 11px; color: #718096;">
                        <span>%${percentage} tamamlandı</span>
                        <span>${customerCount} customer(s) ordered</span>
                    </div>

                    ${remaining > 0 ? `
                    <div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #e2e8f0; text-align: center; font-size: 12px; color: #4a5568;">
                        <strong style="color: #2d3748;">${remaining} adet daha</strong> üretimin başlaması için gerekli
                    </div>
                    ` : ''}
                `;

                mainContainer.appendChild(variantContainer);
                });
            }

            // Container'ı sayfaya ekle
            if (insertAfterElement.nextSibling) {
                insertAfterElement.parentNode.insertBefore(mainContainer, insertAfterElement.nextSibling);
            } else {
                insertAfterElement.parentNode.appendChild(mainContainer);
            }

            // CSS ekle (bir kere)
            if (!document.getElementById('variant-progress-styles')) {
                const style = document.createElement('style');
                style.id = 'variant-progress-styles';
                style.textContent = `
                    .variant-progress-main-container {
                        margin: 20px 0;
                        padding: 16px;
                        background: white;
                        border: 1px solid #e2e8f0;
                        border-radius: 8px;
                    }

                    @media (max-width: 749px) {
                        .variant-progress-main-container {
                            padding: 12px;
                            margin: 16px 0;
                        }

                        .variant-progress-container {
                            padding: 10px !important;
                        }
                    }
                `;
                document.head.appendChild(style);
            }

            debug('[Variant Progress] Variant progress bars displayed successfully');
            return true; // Başarılı

        } catch (error) {
            console.error('[Variant Progress] Error:', error);
            debug(`[Variant Progress] Error: ${error.message}`);
            return false; // Başarısız
        }
    }

    // Progress bar display for order quantity - DISABLED
    // Artık option-based progress bar popup içinde gösteriliyor, product page'de progress bar YOK
    async function displayProgressBar() {
        // DISABLED - Product page'de progress bar gösterilmeyecek
        // Sadece popup içindeki option-based progress bar kullanılacak
        return;

        try {
            // Önce varyant bazlı veriyi deneyelim
            const variantBarsDisplayed = await displayVariantProgressBars();

            // Eğer varyant barları gösterildiyse, eski sistemi gösterme
            if (variantBarsDisplayed) {
                return;
            }

            // Varyant barları gösterilemezse eski sisteme dön
            if (!deadlineInfo || !deadlineInfo.stats) {
                debug('No stats data to display progress bar');
                return;
            }

            const { stats, minSiparisAdedi, stokkodu } = deadlineInfo;
            const minQuantity = parseInt(minSiparisAdedi, 10) || 0;
            const currentQuantity = stats.total_quantity || 0;
            const customerCount = stats.total_customers || 0;

            if (minQuantity <= 0) {
                debug('Min quantity is 0 or not set, skipping progress bar');
                return;
            }

            // Calculate percentage (cap at 100%)
            const percentage = Math.min(100, Math.round((currentQuantity / minQuantity) * 100));
            const remaining = Math.max(0, minQuantity - currentQuantity);

            debug(`Progress: ${currentQuantity}/${minQuantity} (${percentage}%) - ${customerCount} customers`);

            // Find deadline countdown to insert after it
            const deadlineCountdown = document.getElementById('preorder-deadline-countdown');
            let insertAfterElement = deadlineCountdown;

            // If no deadline countdown, find product title
            if (!insertAfterElement) {
                const titleSelectors = [
                    'h1.product__title',
                    'h1.product-title',
                    '.product-single__title',
                    '.product__title',
                    'h1[itemprop="name"]',
                    'h1'
                ];

                for (const selector of titleSelectors) {
                    insertAfterElement = document.querySelector(selector);
                    if (insertAfterElement && insertAfterElement.offsetParent !== null) {
                        break;
                    }
                }
            }

            if (!insertAfterElement) {
                debug('Could not find element to insert progress bar after');
                return;
            }

            // Remove existing progress bar
            const existingProgress = document.getElementById('preorder-progress-bar');
            if (existingProgress) {
                existingProgress.remove();
            }

            // Create progress bar container
            const progressContainer = document.createElement('div');
            progressContainer.id = 'preorder-progress-bar';
            progressContainer.className = 'preorder-progress-container';

            // Determine color based on percentage
            let barColor = '#3182ce'; // Default blue
            let statusText = 'Collecting Orders';
            let statusIcon = '📦';

            if (percentage >= 100) {
                barColor = '#38a169'; // Green - reached goal
                statusText = 'Goal Reached!';
                statusIcon = '✅';
            } else if (percentage >= 75) {
                barColor = '#d69e2e'; // Yellow/orange - almost there
                statusText = 'Almost There';
                statusIcon = '🔥';
            } else if (percentage >= 50) {
                barColor = '#3182ce'; // Blue - halfway
                statusText = 'Progress Ongoing';
                statusIcon = '📈';
            }

            progressContainer.innerHTML = `
                <div class="progress-header">
                    <span class="progress-status">${statusIcon} ${statusText}</span>
                    <span class="progress-count">${currentQuantity} / ${minQuantity} units</span>
                </div>
                <div class="progress-bar-wrapper">
                    <div class="progress-bar-fill" style="width: ${percentage}%; background-color: ${barColor};"></div>
                </div>
                <div class="progress-footer">
                    <span class="progress-percentage">%${percentage} tamamlandı</span>
                    <span class="progress-customers">${customerCount} customers ordered</span>
                </div>
                ${remaining > 0 ? `
                <div class="progress-remaining">
                    <span><strong>${remaining} adet daha</strong> üretimin başlaması için gerekli</span>
                </div>
                ` : ''}
            `;

            // Insert after deadline countdown (or after title if no countdown)
            if (insertAfterElement.nextSibling) {
                insertAfterElement.parentNode.insertBefore(progressContainer, insertAfterElement.nextSibling);
            } else {
                insertAfterElement.parentNode.appendChild(progressContainer);
            }

            // Add CSS styles
            if (!document.getElementById('preorder-progress-styles')) {
                const style = document.createElement('style');
                style.id = 'preorder-progress-styles';
                style.textContent = `
                    .preorder-progress-container {
                        margin: 12px 0 16px 0;
                        padding: 14px 16px;
                        background: #f7fafc;
                        border: 1px solid #e2e8f0;
                        border-radius: 4px;
                    }
                    .progress-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 10px;
                        font-size: 13px;
                    }
                    .progress-status {
                        font-weight: 600;
                        color: #2d3748;
                    }
                    .progress-count {
                        font-weight: 600;
                        color: #4a5568;
                    }
                    .progress-bar-wrapper {
                        width: 100%;
                        height: 12px;
                        background: #e2e8f0;
                        border-radius: 6px;
                        overflow: hidden;
                        margin-bottom: 8px;
                    }
                    .progress-bar-fill {
                        height: 100%;
                        border-radius: 6px;
                        transition: width 0.5s ease-in-out;
                    }
                    .progress-footer {
                        display: flex;
                        justify-content: space-between;
                        font-size: 11px;
                        color: #718096;
                    }
                    .progress-percentage {
                        font-weight: 500;
                    }
                    .progress-customers {
                        font-style: italic;
                    }
                    .progress-remaining {
                        margin-top: 10px;
                        padding-top: 10px;
                        border-top: 1px solid #e2e8f0;
                        font-size: 12px;
                        color: #4a5568;
                        text-align: center;
                    }
                    .progress-remaining strong {
                        color: #2d3748;
                    }

                    /* Mobile responsive */
                    @media (max-width: 749px) {
                        .preorder-progress-container {
                            padding: 12px 14px;
                        }
                        .progress-header {
                            font-size: 12px;
                        }
                        .progress-footer {
                            font-size: 10px;
                        }
                    }
                `;
                document.head.appendChild(style);
            }

            debug('Progress bar displayed successfully');

        } catch (error) {
            console.error('Error displaying progress bar:', error);
            debug(`Progress bar error: ${error.message}`);
        }
    }

    // Real-time countdown update
    function startCountdownTimer() {
        if (countdownInterval) clearInterval(countdownInterval);

        countdownInterval = setInterval(() => {
            if (!deadlineInfo || !deadlineInfo.deadline) {
                clearInterval(countdownInterval);
                return;
            }

            const remaining = calculateTimeRemaining(deadlineInfo.deadline);
            const timerText = document.getElementById('deadline-timer-text');

            if (!timerText) {
                clearInterval(countdownInterval);
                return;
            }

            if (remaining.expired) {
                // Deadline expired
                clearInterval(countdownInterval);

                const countdownContainer = document.getElementById('preorder-deadline-countdown');
                if (countdownContainer) {
                    countdownContainer.innerHTML = `
                        <div class="deadline-expired">
                            <svg class="deadline-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <circle cx="12" cy="12" r="10" stroke-width="2"/>
                                <polyline points="12 6 12 12 16 14" stroke-width="2"/>
                            </svg>
                            <span class="deadline-text">Pre-order period has ended</span>
                        </div>
                    `;
                }

                // Disable buttons
                disablePreorderButtons();

            } else {
                // Timer'ı güncelle
                timerText.textContent = remaining.text;

                // Urgent durumu güncelle
                const container = timerText.closest('.deadline-active');
                if (container) {
                    if (remaining.urgent) {
                        container.classList.add('deadline-urgent');
                    } else {
                        container.classList.remove('deadline-urgent');
                    }
                }
            }

        }, 1000); // Her saniye güncelle
    }

    // Preorder butonlarını disable et
    function disablePreorderButtons() {
        debug('Disabling preorder buttons - deadline expired');

        // Replacement button'ı disable et
        const replacementBtn = document.getElementById('preorder-replacement-btn');
        if (replacementBtn) {
            replacementBtn.disabled = true;
            replacementBtn.style.opacity = '0.5';
            replacementBtn.style.cursor = 'not-allowed';
            replacementBtn.textContent = 'Ön Sipariş Süresi Doldu';
            replacementBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                alert('Üzgünüz, bu ürün için ön sipariş süresi dolmuştur.');
            });
        }

        // Trigger button'ı disable et
        const triggerBtn = document.querySelector('.preorder-trigger-btn');
        if (triggerBtn) {
            triggerBtn.disabled = true;
            triggerBtn.style.opacity = '0.5';
            triggerBtn.style.cursor = 'not-allowed';
            triggerBtn.textContent = 'Ön Sipariş Süresi Doldu';
        }

        debug('Preorder buttons disabled');
    }

    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
        if (countdownInterval) clearInterval(countdownInterval);
    });

    ready(() => {
        debug('DOM ready, starting initialization');
        init();

        if (!isInitialized) {
            debug('Starting observers for lazy loading');
            observeForPreorderElement();
            observeForAddToCartButton();
        }

        // Varyant değişikliklerini dinlemeye başla
        observeVariantChanges();
    });

    // Debug mode için window'a fonksiyonlar ekle
    if (PREORDER_CONFIG.enableDebug) {
        window.preorderDebug = {
            getInfo: () => debugInfo,
            getConfig: () => PREORDER_CONFIG,
            reinit: () => {
                isInitialized = false;
                init();
            },
            testAPI: async (testData) => {
                return await sendToAPI(testData || {
                    test: true,
                    timestamp: new Date().toISOString()
                });
            },
            restoreAddToCart: () => {
                if (originalAddToCartButton) {
                    originalAddToCartButton.classList.remove('preorder-add-to-cart-hidden');
                    const replacement = document.getElementById('preorder-replacement-btn');
                    if (replacement) {
                        replacement.remove();
                    }
                }
            },
            getCurrentPrice: () => currentPrice,
            getBasePrice: () => basePrice,
            recalculatePrice: calculatePrice,
            // Variant debug fonksiyonları
            getAllVariants: getAllSelectedVariants,
            getVariantCode: getSelectedVariantCode,
            getVariantOptions: getProductVariantOptions,
            createVariantSelects: createVariantSelects,
            syncToProductPage: syncVariantToProductPage,
            syncToPopup: syncVariantToPopup,
            // Deadline debug fonksiyonları
            testDeadline: async () => {
                console.log('=== Testing Deadline Functionality ===');
                const info = await fetchDeadlineInfo();
                console.log('Deadline Info:', info);
                return info;
            },
            showDeadline: async () => {
                console.log('=== Forcing Deadline Display ===');
                await displayDeadlineCountdown();
            },
            getDeadlineInfo: () => deadlineInfo
        };
    }

})();
